import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { translateRiskProbability, translateRiskImpact } from './riskI18nUtils';
import { useTable } from "react-table";
import ReactDOM from "react-dom";
import CloseIcon from "../../assets/images/close.png";
import { useDrop } from 'react-dnd';
import UnitsTopBar from "../../components/UnitsTopBar";
import Popup from 'reactjs-popup';
/*
import ArrowUpRed from "../../assets/images/arrow_up_red.png";
import ArrowDownRed from "../../assets/images/arrow_down_red.png";
import ArrowUpGreen from "../../assets/images/arrow_up_green.png";

import LOADER from "../../assets/images/loader.svg";
import LOADER_BLUE from "../../assets/images/loader_blue.svg";


import PREVENTIVE from "../../assets/images/preventive.svg";
*/
import { useDrag, useDragLayer, DragPreviewImage  } from "react-dnd";
import { useDragDropManager } from "react-dnd";

import { useHistory } from "react-router-dom";
import ArrowUpRed from "../../assets/images/arrow_up_red.png";
import ArrowDownGreen from "../../assets/images/arrow_down_green.png";
import Nill from "../../assets/images/nill.png";
import UnitsSideBar from "../../components/UnitsSideBar";
import { Disable } from 'react-disable';
import { TfiTrash, TfiAlert, TfiLightBulb } from "react-icons/tfi";
import { openOverlay, deleteRisk, gotoRiskDashboard, gotoBowtie, getControls_Report } from "../../store/actions/riskActions";
import { setSidebarCollapsed } from "../../store/actions/authActions";
import { connect } from "react-redux";
import { compose } from "redux";
import RiskMatrixSingle from '../Charts/Risk/RiskMatrixSingle';
import { assignControlToRisk, closeOverlay, editRiskSave, getRisk, getLevels, addComment, addControl, addAction, addAttachment, editRisk, editControl, editAction, deleteControl, deleteAction, aiControlDrop } from "../../store/actions/riskActions";
import ControlOverlay from '../Control/ControlOverlay';
import ActionOverlay from '../Action/ActionOverlay';
import Select from 'react-select'
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import debounce from "lodash/debounce";
import { set } from 'lodash';
import { fromArray } from '@amcharts/amcharts4/.internal/core/utils/Iterator';
import { closeIncident } from '../../store/actions/incidentActions';
import IncidentDetailsForm from "../../components/Incidents/IncidentOverlay";
import callOpenAIAPI from '../../utils/openAI';
import DraggableControlCard from './DraggableControlCard';
import TopBar from '../TopBar';
import Sidebar from '../Sidebar';
import { getRiskDashboardData } from "../../store/actions/dashboardActions";
import { getComplianceStandardsByCompany } from "../../store/actions/complianceActions"
import ComplianceTopBar from "../../components/ComplianceTopBar";

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        border: 'none', // Remove the border
        boxShadow: state.isFocused
            ? 'inset 0 -2px 0 0 #3b3b3b' // Add a focused bottom border effect using boxShadow
            : 'none', // Default to light gray bottom shadow
        backgroundColor: '#F8F8F8',
        padding: 1,
        transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
        '&:hover': {
            boxShadow: state.isFocused
                ? 'inset 0 -2px 0 0 #3b3b3b' // Keep dark blue on hover if focused
                : 'inset 0 -2px 0 0 #ccc', // Otherwise, show light gray on hover
        },
    }),

    menu: (provided) => ({
        ...provided,
        border: 'none', // Remove the border around the menu
        zIndex: 999999999999, // Ensures the menu appears above other elements
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#3b3b3b'
            : state.isFocused
                ? '#F8F8F8'
                : 'white', // Different background colors for selected, focused, and default
        color: state.isSelected ? 'white' : '#000',
        '&:hover': {
            backgroundColor: '#F8F8F8', // Light background on hover
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#3b3b3b',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#000',
    }),
};

const formatCurrency = (value) => {
    if (value >= 1_000_000) {
        return `${(value / 1_000_000).toFixed(1)}M`; // Convert to millions with one decimal
    } else if (value >= 1_000) {
        return `${(value / 1_000).toFixed(1)}K`; // Convert to thousands with one decimal
    }
    return value; // For values less than 1K, display the raw number
};

const probabilityOption = (props) => {
    const { innerRef, innerProps, data, isFocused, selectProps } = props;
    const { context, setHoveredData } = selectProps;
    //////////////console.log("data: ", data);

    let displayValue;
    if (context === "probability") {
        displayValue = data.frequency;
    } else if (context === "operational") {
        displayValue = data.impact.operational;
    } else if (context === "financial") {
        const v = data.value;
        if (v === 'Catastrophe') {
            displayValue = `> $${formatCurrency(data.impact.financial_low || 0)}`;
        } else if (v === 'Insignificant') {
            displayValue = `< $${formatCurrency(data.impact.financial_high || 0)}`;
        } else {
            displayValue = `$${formatCurrency(data.impact.financial_low || 0)} - $${formatCurrency(data.impact.financial_high || 0)}`;
        }
    } else if (context === "reputational") {
        displayValue = data.impact.reputational;
    } else if (context === "strategic") {
        displayValue = data.impact.strategic;
    }
    else {
        setHoveredData(null);
    }

    //////////////console.log("displayValue:",displayValue);

    const handleMouseEnter = (event) => {
        const rect = event.currentTarget.getBoundingClientRect(); // ✅ currentTarget not target

        // Measure tooltip size (so we can flip left/right if needed)
        const tempDiv = document.createElement("div");
        tempDiv.style.position = "fixed";
        tempDiv.style.visibility = "hidden";
        tempDiv.style.whiteSpace = "nowrap";
        tempDiv.style.font = "inherit";
        tempDiv.textContent = displayValue;
        document.body.appendChild(tempDiv);
        const hoverWidth = tempDiv.offsetWidth;
        const hoverHeight = tempDiv.offsetHeight;
        document.body.removeChild(tempDiv);

        const gap = 10;

        // Default: show to the right
        let left = rect.right + gap;
        let top = rect.top + rect.height / 2 - hoverHeight / 2;

        // If would overflow right edge -> flip to left
        if (left + hoverWidth > window.innerWidth - 8) {
            left = rect.left - hoverWidth - gap;
        }

        // Clamp vertically (keep on screen)
        top = Math.max(8, Math.min(top, window.innerHeight - hoverHeight - 8));

        setHoveredData({
            value: displayValue,
            position: { top, left }, // ✅ viewport coords for position: fixed
        });
    };

    const handleMouseLeave = () => setHoveredData(null);


    return (
        <div
            ref={innerRef}
            {...innerProps}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{
                display: 'flex',
                alignItems: 'center',
                padding: 10,
                backgroundColor: isFocused ? '#e6f7ff' : 'white',
                cursor: 'pointer',
            }}
        >
            {/* Color Indicator */}
            <div
                style={{
                    width: 20,
                    height: 20,
                    marginRight: 10,
                    backgroundColor: data.color,
                    borderRadius: 5,
                }}
            />
            <span>{data.label}</span>
        </div>
    );
};

const probabilitySingleValue = (props) => {
    const { data } = props;
    const v = data.value;
    const short =
        v === "Almost certain" ||
        v === "Almost Certain" ||
        v === "Catastrophe" ||
        v === "Not started"
            ? `${String(data.label).substring(0, 7)}...`
            : data.label;
    return data.label !== "Preventive" && data.label !== "Detective" && data.label !== "Corrective" ? (
        <div style={{ display: 'flex', alignItems: 'center', padding: 0 }}>
            <div style={{ width: 10, height: 10, marginRight: 5, backgroundColor: data.color, color: data.color, Radius: 5 }} />
            {short}
        </div>
    ) : (
        <div style={{ display: 'flex', alignItems: 'center', padding: 0 }}>
            {short}
        </div>
    );
};



const getRiskColor = (value, max = 25) => {
    const v = Math.max(0, Math.min(max, Number(value) || 0));
    const ratio = v / max;

    // blue (low) → red (high)
    const r = Math.round(59 + ratio * (239 - 59));   // 59 → 239
    const g = Math.round(130 - ratio * 70);          // 130 → 60
    const b = Math.round(246 - ratio * 200);         // 246 → 46

    return `rgb(${r}, ${g}, ${b})`;
};

const getTrendArrow = (value, history) => {
    if (history == null || value == null) return null;

    if (history - value > 0) return "down"; // improvement
    if (history - value < 0) return "up";   // worse
    return null;
};








const RiskPage = (props) => {

    const { t } = useTranslation();
    const { assignControlToRiskFN, assignable_controls, getControlsReportFN, activeComplianceId, setSidebarCollapsedFN, sidebar_collapsed, companies, go_to_risk_dashboard, gotoRiskDashboardFN, go_to_bowtie, gotoBowtieFN, departments, getComplianceStandardsByCompanyFN, risk_dashboard_data, getRiskDashboardDataFN, activeDepartmentId, closeIncidentFN, closeOverlayFN, framework, complianceStandards, editRiskSaveFN, mode, risk, levels, getRiskFN, getLevelsFN, close, openIncident, risk_id, addCommentFN, addControlFN, addActionFN, /*addAttachmentFN,*/ editRiskFN, editControlFN, editActionFN, profile, deleteControlFN, openControl, controlopen, openAction, actionopen, deleteActionFN, aiControlDropFN } = props;

    const [control_id, setControlId] = useState(null);
    const [action_id, setActionId] = useState(null);
    const [isIncidentOpen, setIsIncidentOpen] = useState(false);
    const routeRiskId =
        props.match && props.match.params && props.match.params.id
            ? props.match.params.id
            : null;

    const effectiveRiskId = routeRiskId || props.risk_id;
    ////////console.log("effectiveRiskId ", effectiveRiskId)

    const history = useHistory();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    ////////console.log(location.pathname)
    const fromPage = location.state?.from || 'Global';


    const updateRiskServerData = async (data, risk_id) => {
        ////console.log("Update data", data)
        setLoading(true);
        await editRiskFN(risk_id, data);
        setLoading(false);
    }

    ////////console.log("fromPage ", fromPage)
    const closeCreation = async (data, risk_id) => {

        //////////////console.log("getting risks 3");

        // To DO setControls([]);
        // await updateRiskServerData(data, risk_id)



        // await closeOverlayFN();
        //console.log("fromPage ", fromPage)
        if (fromPage == 'risk center') {
            // if (mode === 'Compliance') {
            //     history.push('/risk_center', { activeMenuItem: 'risk', ComplianceFromRedirect: activeComplianceId });
            // } else {
            //     history.push('/risk_center', { activeMenuItem: 'risk', departmentfromredirect: activeDepartmentId });
            // }
            history.push('/risk_center', { activeMenuItem: 'risk', departmentfromredirect: activeDepartmentId });
        } else {
            history.goBack()
        }




    }




    const [menuPos, setMenuPos] = React.useState(null);


    const sectionRefs = React.useRef({
        risk: null,
        bowtie: null,
        stats: null,
        changelog: null,
    });

    const scrollToSection = (key) => {
        if (key == "bowtie") {
            gotoBowtieFN(risk_id)
        }
        if (key == "stats") {
            gotoRiskDashboardFN(risk_id)
        }
    };

    useEffect(() => {
        if (go_to_bowtie) {
            history.push({ pathname: `/bowtie/${go_to_bowtie}` });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [go_to_bowtie]);

    useEffect(() => {
        if (go_to_risk_dashboard) {
            history.push({ pathname: `/dashboards/${go_to_risk_dashboard}` });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [go_to_risk_dashboard]);




    const isExitingRef = useRef(false);



    const closeControl = async (data, control_id) => {
        //////////console.log("closeControl")
        setControlId(null);
        await updateControlServerData(data, control_id)
    }

    const closeAction = async (data, action_id) => {
        //////////////console.log("closeAction")
        setActionId(null);
        await updateActionServerData(data, action_id)

    }

    const updateControlServerData = async (data, control_id) => {

        const updatedData = { ...data };

        // Add one day to StartDate and EndDate if they exist
        if (updatedData.StartDate) {
            const startDate = new Date(updatedData.StartDate);
            startDate.setDate(startDate.getDate() + 1);
            updatedData.StartDate = startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        }

        if (updatedData.EndDate) {
            const endDate = new Date(updatedData.EndDate);
            endDate.setDate(endDate.getDate() + 1);
            updatedData.EndDate = endDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        }

        //////////console.log("CONTROL DATA AFTER ADJUSTMENT", updatedData);

        setLoading(true);
        await editControlFN(risk_id, control_id, updatedData);
        setLoading(false);
    }


    const updateActionServerData = async (data, action_id) => {

        ////////////console.log("ACTION DATA BEFORE ADJUSTMENT", data);

        // Clone data to avoid modifying state directly
        //////////console.log("Action:", data, "action_id:", action_id)
        const updatedData = { ...data };

        // Add one day to StartDate and EndDate if they exist
        if (updatedData.StartDate) {
            const startDate = new Date(updatedData.StartDate);
            startDate.setDate(startDate.getDate() + 1);
            updatedData.StartDate = startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        }

        if (updatedData.EndDate) {
            const endDate = new Date(updatedData.EndDate);
            endDate.setDate(endDate.getDate() + 1);
            updatedData.EndDate = endDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        }

        ////////////console.log("ACTION DATA AFTER ADJUSTMENT", updatedData);

        setLoading(true);
        editActionFN(risk_id, action_id, updatedData);
        setLoading(false);
    }




    const closeIncident = () => {
        //////////////console.log("closeIncident")
        closeIncidentFN()
        setIsIncidentOpen(false);

    }

    const [controls, setControls] = useState([]);
    const [loadingAI, setLoadingAI] = useState(false); // For loading state during API call
    const [showControls, setShowControls] = useState(false); // Tracks when to show controls with animation

    const onRemoveControl = (id) => {
        setControls(prevControls => prevControls.filter(c => c.id !== id));
    };

    const fetchAISuggestions = async (title, details, threats) => {
        setShowControls(false);
        setLoadingAI(true); // Show loading indicator
        //////////////console.log("loadingAI set to true");
        try {
            // Call the backend API for the `suggestControl` use case
            const aiResponse = await callOpenAIAPI(title, details, threats);
            //console.log("aiResponse1",aiResponse)
            const parsedControls = aiResponse.map((control, i) => ({
                ...control,
                id: crypto.randomUUID?.() || `control-${i}`,
            }));
            setControls(parsedControls);

            ////////console.log("aiResponse", parsedControls)
            // Introduce a delay before showing controls
            setTimeout(() => {
                setShowControls(true); // Trigger animation
            }, 300); // 300ms delay for animation

        } catch (error) {
            console.error("Error fetching AI suggestions:", error);
        } finally {
            setLoadingAI(false); // Hide loading indicator
            //////////////console.log("loadingAI set to false");
            //////////////console.log("AI CONTROLS: ", controls);
        }
    };










    const [isLoading, setIsLoading] = useState(true);



    const [newThreatLocal, setNewThreatLocal] = useState("");
    const [newOpportunityLocal, setNewOpportunityLocal] = useState("");


    const calculateFinancialLoss = (impact) => {
        const formatNumber = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        if (!levels || !levels.riskImpacts) {
            console.error("Levels or riskImpacts not available.");
            return formatNumber(0);
        }

        // Find the corresponding impact in the levels object
        const impactData = levels.riskImpacts.find((riskImpact) => riskImpact.impact === impact);
        //////console.log("levels ", levels)
        if (!impactData) {
            //console.warn(`Impact "${impact}" not found in levels.`);
            return formatNumber(0);
        }

        // Handle the special case for "Catastrophe"
        if (impact === "Catastrophe") {
            return formatNumber(impactData.financial_low * 4 / 3);
        }

        // Calculate the average financial loss for other impacts
        const { financial_high, financial_low } = impactData;
        const average = (financial_high + financial_low) / 2;

        return formatNumber(Math.round(average)); // Format and round the number
    };

    const [commentState, setCommentState] = useState('');

    const [formState, setFormState] = useState({
        Title: '',
        Definition: '',
        DefinitionDate: moment().format('YYYY-MM-DD'),
        RiskType: 'Department',
        DepartmentId: props.department_id,
        ComplianceId: null,
        RiskLevel: 'Low',
        RiskCategory: 'Operational',
        RiskStatus: 'Active',
        RiskOwner: '',
        RiskDescription: '',
        RiskThreats: [],
        riskOpportunities: [],
        RiskImpact: '',
        RiskLikelihood: '',
        vulnerability: '',
        threat: '',
        RiskControls: [],
        RiskActions: [],
        Option_C: 'No',
        Option_I: 'No',
        Option_A: 'No',
        compliance_id: 0,
        opportunity: '',
        company_id: '',
    });


    const Badge = ({ label, value, history, max = 25, description, icon, hoveredData, context, trueVal }) => {
        const newVal = impactWeightMap[value]
        const safeValue = trueVal ? (Number.isFinite(trueVal) ? trueVal : 0) : 0;
        const percent = Math.min(100, (safeValue / max) * 100);
        const barColor = getRiskColor(safeValue, max);
        const trend = getTrendArrow(trueVal, history);
        const listImpact = levels?.riskImpacts



        const textIndex = Math.max(
            0,
            Math.min(5, Number.isFinite(newVal) ? newVal : 0)
        );
        const impactRow = listImpact?.[textIndex - 1] || null;
        //////console.log("newVal ", newVal, "trueVal ", trueVal, "safe Val ", safeValue)

        const impactText = (() => {
            if (!impactRow) return null;

            // normalize the context you pass in: "financial" | "operational" | "reputational" | "strategic"
            if (context === "financial") {
                const lo = impactRow.financial_low;
                const hi = impactRow.financial_high;

                if (lo == null && hi == null) return impactRow.impact || null;

                if (hi == null && lo != null) {
                    return `> $${Number(lo).toLocaleString()}`;
                }

                return `$${Number(lo ?? 0).toLocaleString()} - $${Number(hi ?? 0).toLocaleString()}`;
            }



            if (context === "operational") return impactRow.operational || impactRow.impact || null;
            if (context === "reputational") return impactRow.reputational || impactRow.impact || null;
            if (context === "strategic") return impactRow.strategic || impactRow.impact || null;

            return impactRow.impact || null;
        })();


        ////console.log("listImpact ", listImpact)

        ////console.log("financial_inherent ", formState.financial_inherent)
        return (
            <div className="w-full min-w-0 rounded-md border border-gray-200 bg-white px-2 py-1.5">

                {/* Top row */}
                <div className="flex items-center justify-between mb-0.5">
                    <div className="flex items-center gap-1.5 min-w-0 flex-1">
                        <div className="w-5 h-5 rounded bg-gray-100 flex items-center justify-center text-[10px]">
                            {icon}
                        </div>
                        <span className="min-w-0 flex-1 text-[11px] font-medium text-gray-800 leading-tight truncate">

                            {label}
                        </span>
                    </div>

                    {/* score + arrow */}
                    <div className="flex items-center gap-1 text-[10px] font-medium text-gray-700">
                        {trend === "up" && (
                            <img src={ArrowUpRed} alt="Up" className="w-2.5 h-2.5" />
                        )}
                        {trend === "down" && (
                            <img src={ArrowDownGreen} alt="Down" className="w-2.5 h-2.5" />
                        )}
                        <span>{safeValue}/{max}</span>
                    </div>
                </div>

                {/* Progress bar */}
                <div className="w-full h-1 rounded-full bg-gray-200 overflow-hidden mb-0.5">
                    <div
                        className="h-full rounded-full transition-all duration-300"
                        style={{
                            width: `${percent}%`,
                            backgroundColor: barColor,
                        }}
                    />
                </div>

                <div className="text-[10px] text-gray-500 leading-tight truncate">
                    {impactText || description}
                </div>

            </div>
        );
    };

    const handleSectionNav = async (section) => {
        if (isExitingRef.current) return;

        await updateRiskServerData(formState, risk_id);
        scrollToSection(section);
    };

    const runExitFlow = useCallback(async () => {
        if (isExitingRef.current) return;
        isExitingRef.current = true;

        await updateRiskServerData(formState, risk_id); // <-- YOUR existing data
        await closeOverlayFN();
    }, [formState, risk_id, updateRiskServerData, closeOverlayFN]);


    useEffect(() => {
        // Block ANY navigation away from this page (push, goBack, link clicks, etc)
        const unblock = history.block((tx) => {
            // allow if we're already exiting, or staying on same path
            if (isExitingRef.current) return true;

            // stop navigation now
            (async () => {
                await runExitFlow();

                // allow navigation after exit flow finishes
                unblock();
                history.push(tx.pathname + (tx.search || "") + (tx.hash || ""), tx.state);
            })();

            return false;
        });

        return () => unblock();
    }, [history, runExitFlow]);

    const [formActionState, setFormActionState] = useState([]);
    const [formControlState, setFormControlState] = useState([]);

    useEffect(() => {
        //console.log("Company_id " ,formState.company_id)
        if(formState.company_id)
            
            getLevelsFN(formState.company_id);
    }, [getLevelsFN, formState]);

    const getColorForScale = (scale) => {
        const colors = {
            "Rare": "#0081A7",
            "Unlikely": "#00AFB9",
            "Possible": "#FED9B7",
            "Likely": "#F07167",
            "Almost certain": "#b4170b",
        };
        return colors[scale] || "#000000"; // Default to black if scale not found
    };

    const getColorForScaleImpact = (scale) => {
        const colors = {
            "Insignificant": "#0081A7",
            "Minor": "#00AFB9",
            "Moderate": "#FED9B7",
            "Major": "#F07167",
            "Catastrophe": "#b4170b",
        };
        return colors[scale] || "#000000"; // Default to black if scale not found
    };

    const listUsers = risk && risk.users ? risk.users.map(user => ({ value: user.UserID, label: user.FirstName + ' ' + user.LastName })) : [];
    const listDepartments = risk && risk.departments && profile && (profile.role === "Admin" || profile.role === "Auditor") ? risk.departments.map(department => ({ value: department.DepartmentID, label: department.DepartmentName })) : risk && risk.departments && profile && (profile.role === "User") ? risk.departments.filter(department => department.DepartmentID === profile.department_id).map(department => ({ value: department.DepartmentID, label: department.DepartmentName })) : [];
    const listStatus = useMemo(
        () => [
            { value: 'In Review', label: t('riskOverview.statusOptions.inReview') },
            { value: 'Approved', label: t('riskOverview.statusOptions.approved') },
        ],
        [t]
    );

    const listProbability = useMemo(
        () =>
            (levels?.riskProbabilities || []).map((prob) => ({
                value: prob.scale,
                label: translateRiskProbability(prob.scale, t),
                color: getColorForScale(prob.scale),
                frequency: prob.frequency,
            })),
        [levels?.riskProbabilities, t]
    );

    const listProbabilityDesc = useMemo(() => [...listProbability].reverse(), [listProbability]);

    const listImpact = useMemo(
        () =>
            (levels?.riskImpacts || []).map((impact) => ({
                value: impact.impact,
                label: translateRiskImpact(impact.impact, t),
                color: getColorForScaleImpact(impact.impact),
                impact,
            })),
        [levels?.riskImpacts, t]
    );

    const listResponses = useMemo(
        () => [
            { value: 'Accept', label: t('riskOverview.riskResponseOptions.accept'), color: "#0081A7" },
            { value: 'Mitigate', label: t('riskOverview.riskResponseOptions.mitigate'), color: "#00AFB9" },
            { value: 'Transfer', label: t('riskOverview.riskResponseOptions.transfer'), color: "#FED9B7" },
            { value: 'Avoid', label: t('riskOverview.riskResponseOptions.avoid'), color: "#F07167" },
        ],
        [t]
    );
    const listPriority = [{ value: 'Low', label: 'Low', color: "#0081A7" }, { value: 'Medium', label: 'Medium', color: "#00AFB9" }, { value: 'High', label: 'High', color: "#FED9B7" }, { value: 'Urgent', label: 'Urgent', color: "#F07167" }];
    const listProgress = [{ value: 'Not started', label: 'Not started', color: "#0081A7" }, { value: 'In progress', label: 'In progress', color: "#00AFB9" }, { value: 'Completed', label: 'Completed', color: "#FED9B7" }];
    const listControlTypes = [{ value: 'Detective', label: 'Detective', color: "#000000" }, { value: 'Preventive', label: 'Preventive', color: "#000000" }, { value: 'Corrective', label: 'Corrective', color: "#000000" }];

    const [menuOpenId, setMenuOpenId] = React.useState(null);

    const toggleMenu = React.useCallback((id) => {
        setMenuOpenId((prev) => (prev === id ? null : id));
    }, []);


    React.useEffect(() => {
        const close = () => setMenuPos(null);

        const onDocClickCapture = (e) => {
            const menuEl = menuContainerRef.current;
            const anchorEl = menuPos?.anchorEl;

            // If click inside menu, ignore
            if (menuEl && menuEl.contains(e.target)) return;

            // If click inside the anchor icon, ignore
            if (anchorEl && anchorEl.contains && anchorEl.contains(e.target)) return;

            close();
        };

        const onKeyDown = (e) => {
            if (e.key === "Escape") close();
        };

        // CAPTURE is key: stopPropagation won't block this
        document.addEventListener("click", onDocClickCapture, true);
        window.addEventListener("scroll", close, true);
        window.addEventListener("wheel", close, true);
        window.addEventListener("resize", close);
        document.addEventListener("keydown", onKeyDown);

        return () => {
            document.removeEventListener("click", onDocClickCapture, true);
            window.removeEventListener("scroll", close, true);
            window.removeEventListener("wheel", close, true);
            window.removeEventListener("resize", close);
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [menuPos]);


    useEffect(() => {
        if (props.isOpen) {
            if (props.isNewRisk) {
                //////////console.log('New risk creation mode');
                setIsLoading(false);
                setFormState({
                    Title: '',
                    Definition: '',
                    DefinitionDate: moment().format('YYYY-MM-DD'),
                    RiskType: 'Department',
                    DepartmentId: props.department_id,
                    ComplianceId: null,
                    RiskLevel: 'Low',
                    RiskCategory: 'Operational',
                    RiskStatus: 'Active',
                    RiskThreats: [],
                    riskOpportunities: [],
                    RiskOwner: '',
                    RiskDescription: '',
                    RiskImpact: '',
                    RiskLikelihood: '',
                    RiskControls: [],
                    RiskActions: [],
                    vulnerability: '',
                    threat: '',
                    Option_C: 'No',
                    Option_I: 'No',
                    Option_A: 'No',
                    compliance_id: 0,
                    opportunity: '',
                    company_id: '',
                });
            } else if (risk?.risk_id) {
                ////////////console.log('Fetching risk data for ID:', risk.risk_id);
                setIsLoading(true);
                //////////console.log("new created risk!")
                getRiskFN(risk.risk_id);
                getComplianceStandardsByCompanyFN();
                getRiskDashboardDataFN(risk.risk_id)
            }
        } else {
            // Reset state when overlay is closed
            setIsLoading(true);
            setFormState({
                Title: '',
                Definition: '',
                DefinitionDate: moment().format('YYYY-MM-DD'),
                RiskType: 'Department',
                DepartmentId: props.department_id,
                ComplianceId: null,
                RiskLevel: 'Low',
                RiskCategory: 'Operational',
                RiskStatus: 'Active',
                RiskOwner: '',
                RiskThreats: [],
                riskOpportunities: [],
                RiskDescription: '',
                RiskImpact: '',
                RiskLikelihood: '',
                RiskControls: [],
                RiskActions: [],
                vulnerability: '',
                threat: '',
                Option_C: 'No',
                Option_I: 'No',
                Option_A: 'No',
                compliance_id: 0,
                opportunity: '',
                company_id: '',
            });
        }
    }, [props.isOpen, risk?.risk_id, props.isNewRisk, getRiskFN, props.department_id]);


    const [showMatrices, setShowMatrices] = React.useState(true);
    const [matrixSize, setMatrixSize] = React.useState(220); // px, tweak default
    const [panelW, setPanelW] = React.useState(320);

    useEffect(() => {
        if (!control_id && formState.DepartmentId) {
            //////////console.log("action!")
            getRiskFN(risk_id);
            getRiskDashboardDataFN(risk_id)
            //console.log(props.department_id)
            getControlsReportFN(formState.DepartmentId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [control_id]);

    useEffect(() => {
        //////////console.log("controlopen ", controlopen)
        if (!action_id) {
            //////////console.log("control!")
            getRiskFN(risk_id);
            getRiskDashboardDataFN(risk_id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [action_id]);

    useEffect(() => {
        if (risk && risk.risk) {
            //console.log('Risk data received:', risk);
            setFormState({
                ...formState,
                Title: risk.risk.Title || '',
                Definition: risk.risk.Definition || '',
                Owner: risk.risk.Owner || '',
                DepartmentID: risk.risk.DepartmentID || '',
                Status: risk.risk.Status || '',
                DefinitionDate: risk.risk.DefinitionDate ? moment(risk.risk.DefinitionDate).format('YYYY-MM-DD') : '',
                probability_inherent: risk.risk.probability_inherent || '',
                financial_inherent: risk.risk.financial_inherent || '',
                operational_inherent: risk.risk.operational_inherent || '',
                reputational_inherent: risk.risk.reputational_inherent || '',
                financial_inherent_score: risk.risk.financial_inherent_score || '',
                operational_inherent_score: risk.risk.operational_inherent_score || '',
                reputational_inherent_score: risk.risk.reputational_inherent_score || '',
                financial_residual_score: risk.risk.financial_residual_score || '',
                operational_residual_score: risk.risk.operational_residual_score || '',
                reputational_residual_score: risk.risk.reputational_residual_score || '',
                financial_future_score: risk.risk.financial_future_score || '',
                operational_future_score: risk.risk.operational_future_score || '',
                reputational_future_score: risk.risk.reputational_future_score || '',
                financial_inherent_score_history: risk.risk.financial_inherent_score_history || '',
                operational_inherent_score_history: risk.risk.operational_inherent_score_history || '',
                reputational_inherent_score_history: risk.risk.reputational_inherent_score_history || '',
                financial_residual_score_history: risk.risk.financial_residual_score_history || '',
                operational_residual_score_history: risk.risk.operational_residual_score_history || '',
                reputational_residual_score_history: risk.risk.reputational_residual_score_history || '',
                financial_future_score_history: risk.risk.financial_future_score_history || '',
                operational_future_score_history: risk.risk.operational_future_score_history || '',
                reputational_future_score_history: risk.risk.reputational_future_score_history || '',
                probability_residual: risk.risk.probability_residual || '',
                financial_residual: risk.risk.financial_residual || '',
                operational_residual: risk.risk.operational_residual || '',
                reputational_residual: risk.risk.reputational_residual || '',
                probability_future: risk.risk.probability_future || '',
                financial_future: risk.risk.financial_future || '',
                operational_future: risk.risk.operational_future || '',
                reputational_future: risk.risk.reputational_future || '',
                risk_response: risk.risk.RiskResponse || '',
                ComplianceRisk: risk.risk.ComplianceRisk || '',
                StrategicImpact: risk.risk.StrategicImpact || '',
                vulnerability: risk.risk.vulnerability || '',
                threat: risk.risk.threat || '',
                RiskThreats: risk.threats || [],
                riskOpportunities: risk.opportunity || [],
                Option_C: risk.risk.Option_C || 'No',
                Option_I: risk.risk.Option_I || 'No',
                Option_A: risk.risk.Option_A || 'No',
                compliance_id: risk.risk.compliance_id || 0,
                opportunity: risk.risk.opportunity || '',
                company_id: risk.risk.CompanyID || '',
            });

            //alert(risk.risk.ComplianceRisk);
            ////console.log("risk ~Opportunities ", formState.riskOpportunities)
            ////console.log("Risk ~Threats ", formState.RiskThreats)
            setFormActionState([]);



            risk.actions.map(action => {



                let newaction_Progress = listProgress.find(progress => progress.value === action.ActionProgress);
                let newaction_Priority = listPriority.find(priority => priority.value === action.ActionPriority);
                let newaction_StartDate = moment(action.ActionStartDate).format('YYYY-MM-DD');
                let newaction_EndDate = moment(action.ActionEndDate).format('YYYY-MM-DD');
                let newaction2 = {
                    ...action,
                    ActionProgress: newaction_Progress,
                    ActionPriority: newaction_Priority,
                    ActionStartDate: newaction_StartDate,
                    ActionEndDate: newaction_EndDate
                };

                return setFormActionState(prevState => [...prevState, newaction2]);

            });

            setFormControlState([]);


            risk.controls.map(control => {

                // //////////////console.log(control);

                let newcontrol_Type = listControlTypes.find(controlType => controlType.value === control.ControlType);

                ////////////////console.log(newcontrol_Type);

                let newcontrol = {
                    ...control,
                    ControlType: newcontrol_Type
                };

                return setFormControlState(prevState => [...prevState, newcontrol]);
            });

        }
        //////////////console.log(risk);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [risk]);




    useEffect(() => {
        if (risk) {
            setIsLoading(false);
        }
    }, [risk]);






    const handleRiskChange = (data) => {

        setFormState(data);
        //updateServerData(data, "risk");

    };

    const handleAddAction = async (risk_id) => {
        //////////console.log("Addding Action ", formState)
        await editRiskSaveFN(risk_id, formState)
        addActionFN(risk_id || null)

    }
    const handleDeleteAction = async (risk_id, action_id) => {
        //////////console.log("Deleting Action")
        await editRiskSaveFN(risk_id, formState)
        deleteActionFN(risk_id, action_id);

    }
    const handleAddControl = async (risk_id) => {
        //console.log("Addding Control")
        await editRiskSaveFN(risk_id, formState)
        addControlFN(risk_id, formState.Owner)

    }

    const handleAssignControl = async (risk_id) => {
        const filteredControls = (assignable_controls || [])
            .flatMap((r) => r.controls || [])
            .filter((ctrl) => {
                const ids = ctrl.RiskIds || ctrl.riskIds || [];
                return !ids.includes(Number(risk_id));
            });
        setIsAssignControlsOpen(true)
        setAssignCandidates(filteredControls);
        //console.log("filteredControls", filteredControls);
    };
    const handleDeleteControl = async (risk_id, control_id) => {
        //////////console.log("Deleting Control")
        await editRiskSaveFN(risk_id, formState)
        deleteControlFN(risk_id, control_id)

    }
    const handleAddComment = async (risk_id) => {
        //////////console.log("Addding Comment")
        await editRiskSaveFN(risk_id, formState)
        addCommentFN(commentState, risk_id);

    }


    // put this once near the top of the component
    const saveSeqRef = useRef(0);

    const probabilityWeightMap = {
        "Rare": 1,
        "Unlikely": 2,
        "Possible": 3,
        "Likely": 4,
        "Almost certain": 5,
    };

    const impactWeightMap = {
        "Insignificant": 1,
        "Minor": 2,
        "Moderate": 3,
        "Major": 4,
        "Catastrophe": 5,
    };

    const probability_inherent_change = async (selectedProbability) => {
        const probabilityWeightMap = {
            "Rare": 1,
            "Unlikely": 2,
            "Possible": 3,
            "Likely": 4,
            "Almost certain": 5,
        };

        const impactWeightMap = {
            "Insignificant": 1,
            "Minor": 2,
            "Moderate": 3,
            "Major": 4,
            "Catastrophe": 5,
        };

        const probabilityWeight = probabilityWeightMap[selectedProbability] || 0;

        // use the CURRENT formState impacts (these are fine)
        const impactWeightF = impactWeightMap[formState.financial_inherent] || 0;
        const impactWeightO = impactWeightMap[formState.operational_inherent] || 0;
        const impactWeightR = impactWeightMap[formState.reputational_inherent] || 0;

        const updatedData = {
            ...formState,
            probability_inherent: selectedProbability,
            financial_inherent_score: probabilityWeight * impactWeightF,
            operational_inherent_score: probabilityWeight * impactWeightO,
            reputational_inherent_score: probabilityWeight * impactWeightR,
        };

        ////console.log("SAVING probability_inherent =", selectedProbability, "| prev =", formState.probability_inherent);


        handleRiskChange(updatedData);


        const mySeq = ++saveSeqRef.current;

        await editRiskFN(risk_id, updatedData);

        if (mySeq !== saveSeqRef.current) return;

        await getRiskDashboardDataFN(risk_id);
    };


    const financial_inherent_change = async (selectedImpact) => {
        const p = formState.probability_inherent;
        const pW = probabilityWeightMap[p] || 0;
        const iW = impactWeightMap[selectedImpact] || 0;

        const updatedData = {
            ...formState,
            financial_inherent: selectedImpact,
            financial_inherent_score: pW * iW,
        };

        handleRiskChange(updatedData);

        const mySeq = ++saveSeqRef.current;
        await editRiskFN(risk_id, updatedData);
        if (mySeq !== saveSeqRef.current) return;
        await getRiskDashboardDataFN(risk_id);
    };

    const operational_inherent_change = async (selectedImpact) => {
        const p = formState.probability_inherent;
        const pW = probabilityWeightMap[p] || 0;
        const iW = impactWeightMap[selectedImpact] || 0;

        const updatedData = {
            ...formState,
            operational_inherent: selectedImpact,
            operational_inherent_score: pW * iW,
        };

        handleRiskChange(updatedData);

        const mySeq = ++saveSeqRef.current;
        await editRiskFN(risk_id, updatedData);
        if (mySeq !== saveSeqRef.current) return;
        await getRiskDashboardDataFN(risk_id);
    };

    const reputational_inherent_change = async (selectedImpact) => {
        const p = formState.probability_inherent;
        const pW = probabilityWeightMap[p] || 0;
        const iW = impactWeightMap[selectedImpact] || 0;

        const updatedData = {
            ...formState,
            reputational_inherent: selectedImpact,
            reputational_inherent_score: pW * iW,
        };

        handleRiskChange(updatedData);

        const mySeq = ++saveSeqRef.current;
        await editRiskFN(risk_id, updatedData);
        if (mySeq !== saveSeqRef.current) return;
        await getRiskDashboardDataFN(risk_id);
    };


    const probability_residual_change = async (selectedProbability) => {
        const pW = probabilityWeightMap[selectedProbability] || 0;

        const iWF = impactWeightMap[formState.financial_residual] || 0;
        const iWO = impactWeightMap[formState.operational_residual] || 0;
        const iWR = impactWeightMap[formState.reputational_residual] || 0;

        const updatedData = {
            ...formState,
            probability_residual: selectedProbability,
            financial_residual_score: pW * iWF,
            operational_residual_score: pW * iWO,
            reputational_residual_score: pW * iWR,
        };

        handleRiskChange(updatedData);

        const mySeq = ++saveSeqRef.current;
        await editRiskFN(risk_id, updatedData);
        if (mySeq !== saveSeqRef.current) return;
        await getRiskDashboardDataFN(risk_id);
    };

    const financial_residual_change = async (selectedImpact) => {
        const p = formState.probability_residual;
        const pW = probabilityWeightMap[p] || 0;
        const iW = impactWeightMap[selectedImpact] || 0;

        const updatedData = {
            ...formState,
            financial_residual: selectedImpact,
            financial_residual_score: pW * iW,
        };

        handleRiskChange(updatedData);

        const mySeq = ++saveSeqRef.current;
        await editRiskFN(risk_id, updatedData);
        if (mySeq !== saveSeqRef.current) return;
        await getRiskDashboardDataFN(risk_id);
    };

    const operational_residual_change = async (selectedImpact) => {
        const p = formState.probability_residual;
        const pW = probabilityWeightMap[p] || 0;
        const iW = impactWeightMap[selectedImpact] || 0;

        const updatedData = {
            ...formState,
            operational_residual: selectedImpact,
            operational_residual_score: pW * iW,
        };

        handleRiskChange(updatedData);

        const mySeq = ++saveSeqRef.current;
        await editRiskFN(risk_id, updatedData);
        if (mySeq !== saveSeqRef.current) return;
        await getRiskDashboardDataFN(risk_id);
    };

    const reputational_residual_change = async (selectedImpact) => {
        const p = formState.probability_residual;
        const pW = probabilityWeightMap[p] || 0;
        const iW = impactWeightMap[selectedImpact] || 0;

        const updatedData = {
            ...formState,
            reputational_residual: selectedImpact,
            reputational_residual_score: pW * iW,
        };

        handleRiskChange(updatedData);
        setHoveredData(null);

        const mySeq = ++saveSeqRef.current;
        await editRiskFN(risk_id, updatedData);
        if (mySeq !== saveSeqRef.current) return;
        await getRiskDashboardDataFN(risk_id);
    };

    // -------------------- FUTURE --------------------

    const probability_future_change = async (selectedProbability) => {
        const pW = probabilityWeightMap[selectedProbability] || 0;

        const iWF = impactWeightMap[formState.financial_future] || 0;
        const iWO = impactWeightMap[formState.operational_future] || 0;
        const iWR = impactWeightMap[formState.reputational_future] || 0;

        const updatedData = {
            ...formState,
            probability_future: selectedProbability,
            financial_future_score: pW * iWF,
            operational_future_score: pW * iWO,
            reputational_future_score: pW * iWR,
        };

        handleRiskChange(updatedData);

        const mySeq = ++saveSeqRef.current;
        await editRiskFN(risk_id, updatedData);
        if (mySeq !== saveSeqRef.current) return;
        await getRiskDashboardDataFN(risk_id);
    };

    const financial_future_change = async (selectedImpact) => {
        const p = formState.probability_future;
        const pW = probabilityWeightMap[p] || 0;
        const iW = impactWeightMap[selectedImpact] || 0;

        const updatedData = {
            ...formState,
            financial_future: selectedImpact,
            financial_future_score: pW * iW,
        };

        handleRiskChange(updatedData);
        setHoveredData(null);

        const mySeq = ++saveSeqRef.current;
        await editRiskFN(risk_id, updatedData);
        if (mySeq !== saveSeqRef.current) return;
        await getRiskDashboardDataFN(risk_id);
    };

    const operational_future_change = async (selectedImpact) => {
        const p = formState.probability_future;
        const pW = probabilityWeightMap[p] || 0;
        const iW = impactWeightMap[selectedImpact] || 0;

        const updatedData = {
            ...formState,
            operational_future: selectedImpact,
            operational_future_score: pW * iW,
        };

        handleRiskChange(updatedData);
        setHoveredData(null);

        const mySeq = ++saveSeqRef.current;
        await editRiskFN(risk_id, updatedData);
        if (mySeq !== saveSeqRef.current) return;
        await getRiskDashboardDataFN(risk_id);
    };

    const reputational_future_change = async (selectedImpact) => {
        const p = formState.probability_future;
        const pW = probabilityWeightMap[p] || 0;
        const iW = impactWeightMap[selectedImpact] || 0;

        const updatedData = {
            ...formState,
            reputational_future: selectedImpact,
            reputational_future_score: pW * iW,
        };

        handleRiskChange(updatedData);
        setHoveredData(null);

        const mySeq = ++saveSeqRef.current;
        await editRiskFN(risk_id, updatedData);
        if (mySeq !== saveSeqRef.current) return;
        await getRiskDashboardDataFN(risk_id);
    };








    const handleAISuggestions = async () => {
        //////////////console.log(formState.Title, formState.Definition);

        if (!(formState.Title || "").trim()) {
            alert("Please fill in the title!", {
                position: "top-center",
                autoClose: 3000, // Closes after 3 seconds
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: { backgroundColor: "#f8f8f8", color: "#000" }, // Custom styling
            });
            return; // Exit function
        }

        if (!(formState.Definition || "").trim()) {
            alert("Please fill in the definition!", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: { backgroundColor: "#f8f8f8", color: "#000" },
            });
            return;
        }
        ////console.log("formState ", formState)
        await editRiskFN(risk_id, formState)
        // Call the API with the current Title and Definition
        fetchAISuggestions(formState.Title, formState.Definition, formState.RiskThreats);
    };

    const [hoveredData, setHoveredData] = useState(null);
    const [isAssignControlsOpen, setIsAssignControlsOpen] = useState(false);
    const [assignCandidates, setAssignCandidates] = useState([]);



    const isDraggingAssignControl = useDragLayer((monitor) => {
        return monitor.isDragging() && monitor.getItemType() === "ASSIGN_CONTROL";
    });

    const [{ isOver }, dropRef] = useDrop(() => ({
        accept: 'CONTROL',
        drop: (item) => {
            //////////////console.log("Dropped item index:", item.index);
            //////////////console.log(controls);
            // Access the correct control from the latest state
            const droppedControl = item.control;
            //////////////console.log("Dropped control:", droppedControl);

            // Handle the drop with the correct control
            handleDrop(droppedControl);
        },
        collect: (monitor) => ({
            isOver: !!monitor.isOver(),
        }),
    }));

    const [{ isAssignOver, canAssignDrop }, assignDropRef] = useDrop(
    () => ({
        accept: "ASSIGN_CONTROL",

        canDrop: (item) => {
            const controlId = Number(item?.controlId);
            const rid = Number(risk_id);

            if (!Number.isFinite(controlId) || !Number.isFinite(rid)) return false;

            const existing = Array.isArray(item?.riskIds) ? item.riskIds.map(Number) : [];
            return !existing.includes(rid);
        },

        drop: async (item, monitor) => {
            if (!monitor.isOver({ shallow: true })) return;

            const controlId = Number(item?.controlId);
            const rid = Number(risk_id);

            if (!Number.isFinite(controlId) || !Number.isFinite(rid)) return;

            const existing = Array.isArray(item?.riskIds) ? item.riskIds.map(Number) : [];
            if (existing.includes(rid)) return;

            //console.log("DROP ASSIGN TABLE", controlId, "->", rid);

            await assignControlToRiskFN(controlId, rid);
            await getRiskFN(rid);
        },

        collect: (monitor) => ({
            isAssignOver: monitor.isOver({ shallow: true }),
            canAssignDrop: monitor.canDrop(),
        }),
    }),
    [risk_id, assignControlToRiskFN, getRiskFN]
);

    const [isAssignDragOver, setIsAssignDragOver] = React.useState(false);
    const [canAssignNativeDrop, setCanAssignNativeDrop] = React.useState(false);

    const getDraggedAssignPayload = React.useCallback((e) => {
        try {
            const raw = e.dataTransfer.getData("application/json");
            if (!raw) return null;
            return JSON.parse(raw);
        } catch (err) {
            return null;
        }
    }, []);


    const handleAssignDragOver = React.useCallback(
    (e) => {
        const payload = getDraggedAssignPayload(e);
        if (!payload) return;

        const controlId = Number(payload?.controlId);
        const rid = Number(risk_id);

        if (!Number.isFinite(controlId) || !Number.isFinite(rid)) return;

        const existing = Array.isArray(payload?.riskIds)
            ? payload.riskIds.map(Number)
            : [];

        const canDrop = !existing.includes(rid);

        if (canDrop) {
            e.preventDefault(); // required for drop to work
            e.dataTransfer.dropEffect = "move";
        }

        setIsAssignDragOver(true);
        setCanAssignNativeDrop(canDrop);
    },
    [getDraggedAssignPayload, risk_id]
);

const handleAssignDragLeave = React.useCallback((e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
        setIsAssignDragOver(false);
        setCanAssignNativeDrop(false);
    }
}, []);


const handleAssignDrop = React.useCallback(
    async (e) => {
        e.preventDefault();

        const payload = getDraggedAssignPayload(e);

        setIsAssignDragOver(false);
        setCanAssignNativeDrop(false);

        if (!payload) return;

        const controlId = Number(payload?.controlId);
        const rid = Number(risk_id);

        if (!Number.isFinite(controlId) || !Number.isFinite(rid)) return;

        const existing = Array.isArray(payload?.riskIds)
            ? payload.riskIds.map(Number)
            : [];

        if (existing.includes(rid)) return;

        //console.log("NATIVE DROP ASSIGN TABLE", controlId, "->", rid);

        await assignControlToRiskFN(controlId, rid);
        await getRiskFN(rid);
    },
    [getDraggedAssignPayload, risk_id, assignControlToRiskFN, getRiskFN]
);

    const combinedDropRef = React.useCallback(
        (node) => {
            // attach existing drop behavior
            dropRef(node);
            // attach new assign behavior
            assignDropRef(node);
        },
        [dropRef, assignDropRef]
    );

    const DND_TYPES = { CONTROL: "CONTROL" };

    const handleDrop = async (droppedControl) => {
        //////////console.log("Control received in handleDrop:", droppedControl);
        //////////console.log("Riks state", formState)
        // Prepare the control data
        console.log("ComplianceTypes ", droppedControl.complianceTypes)
        const controlData = {
            ControlID: droppedControl.ControlID,
            ControlNumber: droppedControl.ControlNumber || 1000,  // Default or new control number
            ControlDetails: droppedControl.title,  // Control details from the dropped control
            ControlDefinition: droppedControl.description,
            ControlType: droppedControl.type,     // Control type from the dropped control
            ControlAttachment: droppedControl.attachment || null, // Control attachment if exists
            ComplianceTypes: droppedControl.complianceTypes || [],
            ChecklistItems: droppedControl.checklist || [],
        };

        // **Optimistic UI update**: Immediately update the frontend with the dropped control
        setFormControlState(prevState => [
            ...prevState,
            controlData  // Add the dropped control to the state immediately
        ]);
        // Call the API
        aiControlDropFN(risk_id, controlData)
            .then((data) => {
                //////////////console.log("AI control drop success:", data);
            })
            .catch((err) => {
                console.error("Error while adding or updating control:", err);
                // Optionally, revert control state if the API call fails
                setFormControlState(prevState => prevState.filter(control => control.ControlID !== droppedControl.ControlID));
            });
    };


    const handleCloseClick = () => {
        if (formState.Title === "Untitled Risk") {
            const confirmed = window.confirm(
                "This risk is still named 'Untitled Risk'. Are you sure you want to close it?"
            );

            if (!confirmed) {
                return; // User said NO — do nothing.
            }
        }

        closeCreation(formState, risk_id); // If confirmed or not untitled, call the real close.
    };

    const changeActiveDepartment = (id) => {
        history.push('/risk_center', { activeMenuItem: 'risk', departmentfromredirect: id });

    };

    const changeActiveCompliance = (id) => {

        history.push('/risk_center', { activeMenuItem: 'risk', ComplianceFromRedirect: id });
    };




    const controlStateById = React.useMemo(() => {
        const m = new Map();
        (formControlState || []).forEach((c) => m.set(c.ControlID, c));
        return m;
    }, [formControlState]);

    const controlRows = React.useMemo(() => {
        return (risk?.controls || []).map((control) => {
            const state = controlStateById.get(control.ControlID);
            ////console.log("Control", control)
            return {
                controlID: control.ControlID,
                controlNumber: control.ControlNumber,
                controlDetails: state?.ControlDetails || "",
                findingNumber: control.findingNumber,
                controlType: control.ControlType
            };
        });
    }, [risk?.controls, controlStateById]);




    const menuOpenIdRef = React.useRef(menuOpenId);
    React.useEffect(() => { menuOpenIdRef.current = menuOpenId; }, [menuOpenId]);

    const riskIdRef = React.useRef(risk_id);
    React.useEffect(() => { riskIdRef.current = risk_id; }, [risk_id]);

    const menuContainerRef = React.useRef(null);
    const menuIconRef = React.useRef(null);

    const handleDeleteControlRef = React.useRef(handleDeleteControl);
    React.useEffect(() => { handleDeleteControlRef.current = handleDeleteControl; }, [handleDeleteControl]);


const AssignControlRow = ({ ctrl, id, riskId, onAssign }) => {
    const controlIdNum = Number(id);

    const controlDetails = ctrl.controlDetails || ctrl.ControlDetails || `CTRL-${id}`;
    const controlDefinition = ctrl.controlDefinition || ctrl.ControlDefinition;
    const controlType = ctrl.controlType || ctrl.ControlType || "-";
    const controlPeriod = ctrl.controlPeriod || ctrl.ControlPeriod || "-";

    const existingRiskIds = Array.isArray(ctrl.RiskIds || ctrl.riskIds)
        ? (ctrl.RiskIds || ctrl.riskIds).map(Number)
        : [];

    const alreadyAssigned = existingRiskIds.includes(Number(riskId));

    return (
        <button
            type="button"
            disabled={alreadyAssigned}
            onClick={() => {
                if (!alreadyAssigned) onAssign(controlIdNum);
            }}
            className={`w-full p-4 border-b border-gray-100 text-left transition ${
                alreadyAssigned
                    ? "bg-gray-50 cursor-not-allowed opacity-60"
                    : "bg-white hover:bg-blue-50 cursor-pointer"
            }`}
        >
            <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                    <div className="text-sm font-semibold text-gray-900 truncate">
                        {controlDetails}
                    </div>

                    {controlDefinition && (
                        <div className="text-xs text-gray-600 mt-1 line-clamp-2">
                            {controlDefinition}
                        </div>
                    )}

                    <div className="text-xs text-gray-500 mt-2">
                        CTRL-{id} • {controlType} • {controlPeriod}
                    </div>
                </div>

                <div className="shrink-0 mt-1">
                    {alreadyAssigned ? (
                        <span className="text-[11px] font-medium text-gray-400">
                            {t("riskOverview.assigned")}
                        </span>
                    ) : (
                        <span className="text-[11px] font-medium text-blue-600">
                            {t("riskOverview.assign")}
                        </span>
                    )}
                </div>
            </div>
        </button>
    );
};


    const columns = React.useMemo(
        () => [
            {
                Header: t("riskOverview.table.number"),
                accessor: "controlNumber",
                id: "controlNumber",
                columnWidth: 110,
                Cell: ({ value }) => <span className="font-semibold">{value}</span>,
            },
            {
                Header: t("riskOverview.table.title"),
                accessor: "controlDetails",
                id: "controlDetails",
                Cell: ({ value }) => (
                    <div className="truncate" title={value || ""}>
                        {value || <span className="text-gray-400">{t("riskOverview.noTitle")}</span>}
                    </div>
                ),
            },

            // ✅ NEW
            {
                Header: t("riskOverview.table.type"),
                accessor: "controlType",
                id: "controlType",
                columnWidth: 120,
                Cell: ({ value }) =>
                    value ? (
                        <span className="px-2 py-0.5 rounded-full bg-gray-100 text-gray-700 text-xs font-medium">
                            {value}
                        </span>
                    ) : (
                        <span className="text-xs text-gray-400">-</span>
                    ),
            },

            {
                Header: t("riskOverview.table.findings"),
                accessor: "findingNumber",
                id: "findingNumber",
                columnWidth: 110,
                Cell: ({ value }) => {
                    const n = Number(value ?? 0);
                    if (!n) return <span className="text-xs text-green-700 font-medium">0</span>;
                    return <span className="text-xs text-red-700 font-semibold">{n}</span>;
                },
            },
          {
    Header: "",
    id: "menu",
    columnWidth: 56,
    Cell: ({ row }) => {
        const id =
            row.original.controlID ??
            row.original.ControlID ??
            row.original.control_id;

        const open = menuPos?.id === id;

        ////console.log("render cell", { id, menuPos, open });

        return (
            <div className="relative inline-block" onClick={(e) => e.stopPropagation()}>
                <i
                    className="fa fa-ellipsis-h cursor-pointer text-[#3b3b3b] hover:text-[#3b3b3b]/50"
                    title={t("riskTable.actions.more")}
                    onClick={(e) => {
                        e.stopPropagation();
                        //console.log("ellipsis clicked", { id });

                        const rect = e.currentTarget.getBoundingClientRect();
                        const menuWidth = 144;
                        const top = rect.bottom + 6;
                        const left = Math.max(8, rect.right - menuWidth);

                      
                        if (menuPos?.id === id) {
                            //console.log("closing existing menu");
                            setMenuPos(null);
                            return;
                        }

                        setMenuPos({
                            id,
                            top,
                            left,
                            width: menuWidth,
                        });
                    }}
                />

                {open && (
                    <div
                        ref={menuContainerRef}
                        className="fixed w-36 bg-white border border-gray-200 rounded-lg shadow-lg z-[999999]"
                        style={{ top: menuPos?.top, left: menuPos?.left }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100"
                            onClick={(e) => {
                                e.stopPropagation();
                                setMenuPos(null);
                                setControlId(id);
                            }}
                        >
                            {t("riskTable.actions.edit")}
                        </button>

                        <button
                            className="w-full text-left px-3 py-2 text-sm text-red-600 hover:bg-red-50"
                            onClick={(e) => {
                                e.stopPropagation();
                                setMenuPos(null);
                                handleDeleteControlRef.current(riskIdRef.current, id);
                            }}
                        >
                            {t("riskTable.actions.delete")}
                        </button>
                    </div>
                )}
            </div>
        );
    },
}
        ],
        [menuPos, t]
    );

    const MATRIX_WRAP_PCT = 0.82;

    const setMenuItem = (id) => {
        ////console.log(id)
        history.push('/risk_center', { activeMenuItem: id, departmentfromredirect: activeDepartmentId });
    }

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns, data: controlRows });

    const MATRIX_TOP_PAD = 7;
    const ICON_SIDEBAR_W = 64;
    const UNITS_SIDEBAR_W = 218;

    const leftOffset = ICON_SIDEBAR_W + (sidebar_collapsed ? 0 : UNITS_SIDEBAR_W);

    return (
        <div className="w-full h-screen overflow-hidden bg-[#F8F8F8]">

            {/* TOP BAR */}
            <div className="fixed top-0 left-0 right-0 h-[64px] z-[200]">
                <TopBar />
            </div>

            {/* LEFT ICON SIDEBAR (50px) */}
            <div className="fixed top-[64px] left-0 bottom-0 w-[64px] z-[120]">
                <Sidebar />
            </div>

            {/* UNITS SIDEBAR (270px) - only when NOT collapsed */}
            {!sidebar_collapsed && (
                <div className="fixed top-[64px] left-[64px] bottom-0 w-[218px] z-[130]">
                    <UnitsSideBar
                        activeDepartmentId={activeDepartmentId}
                        departments={departments}
                        companies={companies}
                        setActiveDepartment={changeActiveDepartment}
                        setActiveCompliance={changeActiveCompliance}
                    />
                </div>
            )}



            {/* TOP BAR
            {mode === "Compliance" ? (
                <div
                    className="fixed top-[64px] right-0 h-[64px] z-[150] transition-[left] duration-300 ease-in-out"
                    style={{ left: `${leftOffset}px` }}
                >
                    <ComplianceTopBar
                        className="w-full h-16 fixed z-10"
                        menuitem={"risk"}
                        setMenuItem={setMenuItem}
                        activeComplianceId={activeComplianceId}
                        complianceStandards={complianceStandards}
                    />
                </div>
            ) : (
                <div
                    className="fixed top-[64px] right-0 h-[64px] z-[150] transition-[left] duration-300 ease-in-out"
                    style={{ left: `${leftOffset}px` }}
                >
                    <UnitsTopBar
                        menuitem={"risk"}
                        setMenuItem={setMenuItem}
                        activeDepartmentId={activeDepartmentId}
                        departments={departments}
                        setSidebarCollapsedFN={setSidebarCollapsedFN}
                        sidebar_collapsed={sidebar_collapsed}
                    />
                </div>
            )} */}

            <div
                className="fixed top-[64px] right-0 h-[64px] z-[150] transition-[left] duration-300 ease-in-out"
                style={{ left: `${leftOffset}px` }}
            >
                <UnitsTopBar
                    menuitem={"risk"}
                    setMenuItem={setMenuItem}
                    activeDepartmentId={activeDepartmentId}
                    departments={departments}
                    setSidebarCollapsedFN={setSidebarCollapsedFN}
                    sidebar_collapsed={sidebar_collapsed}
                />
            </div>


            <div className="w-full h-full pt-[128px] overflow-visible">



                <div
                    className="h-full overflow-auto transition-[padding-left] duration-300 ease-in-out"
                    style={{ paddingLeft: `${leftOffset}px` }}
                >

                    <div className="max-w-[1400px] mx-auto px-6">
                        <div className="grid grid-cols-3 gap-3 items-start">

                            {/* FULL-WIDTH QUICK NAV */}
                            <div className="col-span-3">
                                <div className="px-2 pt-6 pb-2">
                                    <div className="bg-[#F8F8F8] px-6">
                                        <div className="flex items-center gap-8 text-sm">

                                            {/* Back arrow */}
                                            <button
                                                onClick={handleCloseClick}
                                                className="text-gray-500 hover:text-gray-900 transition"
                                            >
                                                ←
                                            </button>

                                            {/* Tabs */}
                                            <div className="flex items-center gap-8">
                                                <button
                                                    className="pb-2.5 border-b-2 border-blue-600 text-blue-600 font-medium"
                                                    onClick={() => handleSectionNav("risk")}
                                                    type="button"
                                                >
                                                    {t("riskOverview.tabs.riskAssessment")}
                                                </button>

                                                <button
                                                    className="pb-2.5 border-b-2 border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-400 transition"
                                                    onClick={() => handleSectionNav("bowtie")}
                                                    type="button"
                                                >
                                                    {t("riskOverview.tabs.bowTie")}
                                                </button>

                                                <button
                                                    className="pb-2.5 border-b-2 border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-400 transition"
                                                    onClick={() => handleSectionNav("stats")}
                                                    type="button"
                                                >
                                                    {t("riskOverview.tabs.stats")}
                                                </button>


                                            </div>

                                        </div>
                                    </div>
                                    <div className="w-[94%] border-b border-gray-300 mt-2" />
                                </div>
                            </div>


                            {/* MAIN CONTENT (unchanged width/center) */}
                            <div className="col-span-2 min-w-0">
                                <div className="max-w-6xl mx-auto">
                                    <div className="bg-[#F8F8F8]   min-h-full">
                                        <div className="p-2">
                                            <div className="mb-6 bg-white rounded-lg shadow-sm border border-gray-200 pt-6 px-6 pb-1">
                                                {/* Section title */}
                                                <div className="mb-3 text-sm font-semibold text-gray-700 tracking-wide">
                                                    {t("riskOverview.riskInformation")}
                                                </div>
                                                <div className="mb-4">
                                                    <input
                                                        type="text"
                                                        placeholder={t("riskOverview.untitledRiskPlaceholder")}
                                                        value={formState.Title}
                                                        onChange={(e) => handleRiskChange({ ...formState, Title: e.target.value })}
                                                        className="w-full p-3 rounded mb-4 bg-[#F8F8F8] text-black text-sm"
                                                        style={{
                                                            border: 'none', // Remove actual borders
                                                            backgroundColor: '#F8F8F8',
                                                            padding: '8px',
                                                            outline: 'none',
                                                            transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
                                                            boxShadow: 'inset 0 0 0 0 #3b3b3b', // Start with no shadow
                                                        }}
                                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')} // Add box-shadow on focus
                                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')} // Remove box-shadow on blur
                                                    />

                                                    <textarea
                                                        placeholder={t("riskOverview.definitionPlaceholder")}
                                                        value={formState.Definition}
                                                        onChange={(e) => handleRiskChange({ ...formState, Definition: e.target.value })}
                                                        className="w-full h-24 p-3 rounded bg-[#F8F8F8] text-black text-sm"
                                                        style={{
                                                            border: 'none', // Remove actual borders
                                                            backgroundColor: '#F8F8F8',
                                                            padding: '8px',
                                                            outline: 'none',
                                                            transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
                                                            boxShadow: 'inset 0 0 0 0 #3b3b3b', // Start with no shadow
                                                        }}
                                                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')} // Add box-shadow on focus
                                                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')} // Remove box-shadow on blur
                                                    />


                                                </div>





                                                {framework === 1 && (
                                                    <>
                                                        <div className="mb-6">

                                                            <label className="block text-sm font-medium text-[#3b3b3b] mb-2">{t("riskOverview.vulnerability")}</label>
                                                            <textarea
                                                                placeholder={t("riskOverview.vulnerabilityPlaceholder")}
                                                                value={formState.vulnerability}
                                                                onChange={(e) => handleRiskChange({ ...formState, vulnerability: e.target.value })}
                                                                className="w-full h-24 p-3 rounded bg-[#F8F8F8] text-black text-sm"
                                                                style={{
                                                                    border: 'none', // Remove actual borders
                                                                    backgroundColor: '#F8F8F8',
                                                                    padding: '8px',
                                                                    outline: 'none',
                                                                    transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
                                                                    boxShadow: 'inset 0 0 0 0 #3b3b3b', // Start with no shadow
                                                                }}
                                                                onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')} // Add box-shadow on focus
                                                                onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')} // Remove box-shadow on blur
                                                            />
                                                        </div>




                                                    </>
                                                )}

                                                {/* Threats + Opportunities row (framework === 1) */}
                                                {framework === 1 ? (
                                                    <div className="flex gap-6 w-full mb-6">
                                                        {/* THREATS (left) */}
                                                        {risk && risk.threats && (
                                                            <div className="w-1/2">
                                                                <div className="bg-red-50 border border-red-200 rounded-lg shadow-sm px-4 pt-4 pb-3">
                                                                    <div className="flex items-center justify-between mb-3">
                                                                        <label className="flex items-center gap-2 text-red-700 text-sm font-semibold">
                                                                            <TfiAlert size={14} className="text-red-600" />
                                                                            <span>{t("riskOverview.threatsCount", { count: formState.RiskThreats?.length || 0 })}</span>
                                                                        </label>
                                                                    </div>

                                                                    <ul className="rounded-md p-0 w-full">
                                                                        {formState.RiskThreats?.map((item, index) => (
                                                                            <li
                                                                                key={item.threat_id || index}
                                                                                className="flex items-center justify-between mb-1 p-1 rounded hover:bg-red-100"
                                                                            >
                                                                                <div className="flex items-center w-full">
                                                                                    <input
                                                                                        type="text"
                                                                                        value={item.text}
                                                                                        onChange={(e) => {
                                                                                            const updated = (formState.RiskThreats || []).map((t, idx) =>
                                                                                                idx === index ? { ...t, text: e.target.value } : t
                                                                                            );
                                                                                            handleRiskChange({ ...formState, RiskThreats: updated });
                                                                                        }}
                                                                                        className="p-1 text-sm bg-transparent focus:outline-none w-full text-red-900"
                                                                                        placeholder={t("riskOverview.enterThreat")}
                                                                                    />
                                                                                </div>

                                                                                <button
                                                                                    className="text-red-600 ml-2 hover:text-red-800"
                                                                                    onClick={() => {
                                                                                        const updated = (formState.RiskThreats || []).filter((_, idx) => idx !== index);
                                                                                        handleRiskChange({ ...formState, RiskThreats: updated });
                                                                                    }}
                                                                                >
                                                                                    <TfiTrash size={16} />
                                                                                </button>
                                                                            </li>
                                                                        ))}
                                                                    </ul>

                                                                    <div className="flex items-center p-1 rounded bg-red-100 mt-2 border border-red-200">
                                                                        <input
                                                                            type="text"
                                                                            className="p-1 text-sm text-red-900 bg-transparent focus:outline-none w-full"
                                                                            placeholder={t("riskOverview.addThreat")}
                                                                            value={newThreatLocal || ""}
                                                                            onChange={(e) => {
                                                                                setNewThreatLocal(e.target.value);
                                                                                handleRiskChange({ ...formState, newThreat: e.target.value });
                                                                            }}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === "Enter" && newThreatLocal?.trim()) {
                                                                                    e.preventDefault();
                                                                                    const newThreats = [
                                                                                        ...(formState.RiskThreats || []),
                                                                                        { text: newThreatLocal.trim() },
                                                                                    ];
                                                                                    setNewThreatLocal("");
                                                                                    handleRiskChange({ ...formState, RiskThreats: newThreats, newThreat: "" });
                                                                                }
                                                                            }}
                                                                            onBlur={() => {
                                                                                if (newThreatLocal?.trim()) {
                                                                                    const newThreats = [
                                                                                        ...(formState.RiskThreats || []),
                                                                                        { text: newThreatLocal.trim() },
                                                                                    ];
                                                                                    setNewThreatLocal("");
                                                                                    handleRiskChange({ ...formState, RiskThreats: newThreats, newThreat: "" });
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* OPPORTUNITIES (right) */}
                                                        {risk && risk.opportunity && (
                                                            <div className="w-1/2">
                                                                <div className="bg-emerald-50 border border-emerald-200 rounded-lg shadow-sm px-4 pt-4 pb-3">
                                                                    <div className="flex items-center justify-between mb-3">
                                                                        <label className="flex items-center gap-2 text-emerald-800 text-sm font-semibold">
                                                                            <TfiLightBulb size={14} className="text-emerald-700" />
                                                                            <span>{formState.riskOpportunities?.length || 0} Opportunities</span>
                                                                        </label>
                                                                    </div>

                                                                    <ul className="rounded-md p-0 w-full">
                                                                        {formState.riskOpportunities?.map((item, index) => (
                                                                            <li
                                                                                key={item.opportunity_id || index}
                                                                                className="flex items-center justify-between mb-1 p-1 rounded hover:bg-emerald-100"
                                                                            >
                                                                                <div className="flex items-center w-full">
                                                                                    <input
                                                                                        type="text"
                                                                                        value={item.text}
                                                                                        onChange={(e) => {
                                                                                            const updated = (formState.riskOpportunities || []).map((o, idx) =>
                                                                                                idx === index ? { ...o, text: e.target.value } : o
                                                                                            );
                                                                                            handleRiskChange({ ...formState, riskOpportunities: updated });
                                                                                        }}
                                                                                        className="p-1 text-sm bg-transparent focus:outline-none w-full text-emerald-900"
                                                                                        placeholder={t("riskOverview.enterOpportunity")}
                                                                                    />
                                                                                </div>

                                                                                <button
                                                                                    className="text-emerald-700 ml-2 hover:text-emerald-900"
                                                                                    onClick={() => {
                                                                                        const updated = (formState.riskOpportunities || []).filter((_, idx) => idx !== index);
                                                                                        handleRiskChange({ ...formState, riskOpportunities: updated });
                                                                                    }}
                                                                                >
                                                                                    <TfiTrash size={16} />
                                                                                </button>
                                                                            </li>
                                                                        ))}
                                                                    </ul>

                                                                    <div className="flex items-center p-1 rounded bg-emerald-100 mt-2 border border-emerald-200">
                                                                        <input
                                                                            type="text"
                                                                            className="p-1 text-sm text-emerald-900 bg-transparent focus:outline-none w-full"
                                                                            placeholder={t("riskOverview.addOpportunity")}
                                                                            value={newOpportunityLocal || ""}
                                                                            onChange={(e) => {
                                                                                setNewOpportunityLocal(e.target.value);
                                                                                handleRiskChange({ ...formState, newOpportunity: e.target.value });
                                                                            }}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === "Enter" && newOpportunityLocal?.trim()) {
                                                                                    e.preventDefault();
                                                                                    const next = [
                                                                                        ...(formState.riskOpportunities || []),
                                                                                        { text: newOpportunityLocal.trim() },
                                                                                    ];
                                                                                    setNewOpportunityLocal("");
                                                                                    handleRiskChange({ ...formState, riskOpportunities: next, newOpportunity: "" });
                                                                                }
                                                                            }}
                                                                            onBlur={() => {
                                                                                if (newOpportunityLocal?.trim()) {
                                                                                    const next = [
                                                                                        ...(formState.riskOpportunities || []),
                                                                                        { text: newOpportunityLocal.trim() },
                                                                                    ];
                                                                                    setNewOpportunityLocal("");
                                                                                    handleRiskChange({ ...formState, riskOpportunities: next, newOpportunity: "" });
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : (
                                                    /* Non-framework-1: keep your current Threats full-width block */
                                                    <>
                                                        <div className="flex gap-6 w-full mb-6">
                                                            {risk && risk.threats && (
                                                                <div className="w-full">
                                                                    <div className="bg-red-50 border border-red-200 rounded-lg shadow-sm px-4 pt-4 pb-3">
                                                                        <div className="flex items-center justify-between mb-3">
                                                                            <label className="flex items-center gap-2 text-red-700 text-sm font-semibold">
                                                                                <TfiAlert size={14} className="text-red-600" />
                                                                                <span>{t("riskOverview.threatsCount", { count: formState.RiskThreats?.length || 0 })}</span>
                                                                            </label>
                                                                        </div>

                                                                        <ul className="rounded-md p-0 w-full">
                                                                            {formState.RiskThreats?.map((item, index) => (
                                                                                <li
                                                                                    key={item.threat_id || index}
                                                                                    className="flex items-center justify-between mb-1 p-1 rounded hover:bg-red-100"
                                                                                >
                                                                                    <div className="flex items-center w-full">
                                                                                        <input
                                                                                            type="text"
                                                                                            value={item.text}
                                                                                            onChange={(e) => {
                                                                                                const updated = (formState.RiskThreats || []).map((t, idx) =>
                                                                                                    idx === index ? { ...t, text: e.target.value } : t
                                                                                                );
                                                                                                handleRiskChange({ ...formState, RiskThreats: updated });
                                                                                            }}
                                                                                            className="p-1 text-sm bg-transparent focus:outline-none w-full text-red-900"
                                                                                            placeholder={t("riskOverview.enterThreat")}
                                                                                        />
                                                                                    </div>

                                                                                    <button
                                                                                        className="text-red-600 ml-2 hover:text-red-800"
                                                                                        onClick={() => {
                                                                                            const updated = (formState.RiskThreats || []).filter((_, idx) => idx !== index);
                                                                                            handleRiskChange({ ...formState, RiskThreats: updated });
                                                                                        }}
                                                                                    >
                                                                                        <TfiTrash size={16} />
                                                                                    </button>
                                                                                </li>
                                                                            ))}
                                                                        </ul>

                                                                        <div className="flex items-center p-1 rounded bg-red-100 mt-2 border border-red-200">
                                                                            <input
                                                                                type="text"
                                                                                className="p-1 text-sm text-red-900 bg-transparent focus:outline-none w-full"
                                                                                placeholder={t("riskOverview.addThreat")}
                                                                                value={newThreatLocal || ""}
                                                                                onChange={(e) => {
                                                                                    setNewThreatLocal(e.target.value);
                                                                                    handleRiskChange({ ...formState, newThreat: e.target.value });
                                                                                }}
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === "Enter" && newThreatLocal?.trim()) {
                                                                                        e.preventDefault();
                                                                                        const newThreats = [
                                                                                            ...(formState.RiskThreats || []),
                                                                                            { text: newThreatLocal.trim() },
                                                                                        ];
                                                                                        setNewThreatLocal("");
                                                                                        handleRiskChange({ ...formState, RiskThreats: newThreats, newThreat: "" });
                                                                                    }
                                                                                }}
                                                                                onBlur={() => {
                                                                                    if (newThreatLocal?.trim()) {
                                                                                        const newThreats = [
                                                                                            ...(formState.RiskThreats || []),
                                                                                            { text: newThreatLocal.trim() },
                                                                                        ];
                                                                                        setNewThreatLocal("");
                                                                                        handleRiskChange({ ...formState, RiskThreats: newThreats, newThreat: "" });
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </>
                                                )}






                                            </div>

                                            <div className="mb-6 bg-white rounded-lg shadow-sm border border-gray-200 pt-6 px-6 pb-1">
                                                {/* Risk Owner, Department, Status, Compliance Standard */}
                                                <div className={`grid ${mode !== "Compliance" ? "grid-cols-4" : "grid-cols-3"} gap-4 mb-6`}>
                                                    <div className="flex flex-col">
                                                        <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.riskOwner")}</label>
                                                        <Select
                                                            options={listUsers}
                                                            placeholder={t("riskOverview.riskOwner")}
                                                            className="text-sm text-black"
                                                            onChange={(e) => handleRiskChange({ ...formState, Owner: e.value })}
                                                            styles={customStyles}
                                                            value={listUsers.find(user => user.value === formState.Owner)}
                                                        />
                                                    </div>

                                                    <div className="flex flex-col">
                                                        <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.department")}</label>
                                                        <Select
                                                            options={listDepartments}
                                                            className="text-black text-sm"
                                                            placeholder={t("riskOverview.department")}
                                                            onChange={(e) => handleRiskChange({ ...formState, DepartmentID: e.value })}
                                                            styles={customStyles}
                                                            value={listDepartments.find(department => department.value === formState.DepartmentID)}
                                                        />
                                                    </div>

                                                    <div className="flex flex-col">
                                                        <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.status")}</label>
                                                        <Select
                                                            options={listStatus}
                                                            placeholder={t("riskOverview.status")}
                                                            className="text-sm"
                                                            onChange={(e) => handleRiskChange({ ...formState, Status: e.value })}
                                                            styles={customStyles}
                                                            value={listStatus.find(status => status.value === formState.Status)}
                                                        />
                                                    </div>

                                                    {mode !== "Compliance" && (
                                                        <div className="flex flex-col">
                                                            <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.complianceStandard")}</label>

                                                            <Select
                                                                options={(complianceStandards || []).map(cs => ({
                                                                    value: String(cs.department_id),
                                                                    label: cs.name,
                                                                }))}
                                                                placeholder={t("riskOverview.complianceStandard")}
                                                                className="text-sm"
                                                                styles={customStyles}
                                                                onChange={(e) =>
                                                                    handleRiskChange({
                                                                        ...formState,
                                                                        compliance_id: e ? Number(e.value) : null, // store as number in state/db
                                                                    })
                                                                }
                                                                value={
                                                                    (() => {
                                                                        const id = formState?.compliance_id;
                                                                        if (id == null) return null;

                                                                        const match = (complianceStandards || []).find(
                                                                            cs => String(cs.department_id) === String(id)
                                                                        );

                                                                        return match
                                                                            ? { value: String(match.department_id), label: match.name }
                                                                            : null;
                                                                    })()
                                                                }
                                                            />
                                                        </div>
                                                    )}

                                                </div>
                                            </div>
                                            <div className="mb-6 bg-white rounded-lg shadow-sm border border-gray-200 pt-6 px-6 pb-1">
                                                {/* Inherent Risk Assessment */}
                                                <h3 className="font-semibold mb-3 text-[#3b3b3b]">{t("riskOverview.inherentAssessment")}</h3>
                                                <div className="grid grid-cols-4 gap-4 mb-4">
                                                    {/*<input
                    type="text"
                    placeholder="Probability"
                    className="p-3   rounded bg-[#F8F8F8] text-black h-10"
                    value={formState.probability_inherent}
                    onChange={(e) => setFormState({ ...formState, probability_inherent: e.target.value })}
                />*/}

                                                    <div className="flex flex-col">
                                                        <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.probability")}</label>
                                                        <Select
                                                            options={listProbabilityDesc}
                                                            placeholder={t("riskOverview.selectPlaceholder")}
                                                            onChange={(e) => {

                                                                probability_inherent_change(e.value);
                                                                setHoveredData(null); // Clear hover value on selection
                                                            }}
                                                            styles={customStyles}
                                                            components={{
                                                                Option: probabilityOption,
                                                                SingleValue: probabilitySingleValue,
                                                            }}
                                                            value={
                                                                formState.probability_inherent
                                                                    ? listProbability.find(
                                                                        (probability) =>
                                                                            probability.value?.toLowerCase() === formState.probability_inherent.toLowerCase()
                                                                    ) || null
                                                                    : null
                                                            }
                                                            className="my-custom-select text-sm"
                                                            classNamePrefix="my-custom-select"
                                                            context="probability"
                                                            setHoveredData={setHoveredData}
                                                        />
                                                    </div>

                                                    {hoveredData && (
                                                        <div
                                                            style={{
                                                                position: "fixed",
                                                                top: hoveredData.position.top,
                                                                left: hoveredData.position.left,
                                                                zIndex: 9999,
                                                                backgroundColor: "white",
                                                                border: "1px solid #ccc",
                                                                borderRadius: "4px",
                                                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                                                padding: "8px",
                                                                whiteSpace: "nowrap",
                                                                pointerEvents: "none",
                                                            }}
                                                        >
                                                            {hoveredData.value}
                                                        </div>
                                                    )}



                                                    <div className="flex flex-col">
                                                        <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.financialImpact")}</label>
                                                        <Select
                                                            options={listImpact}
                                                            placeholder={t("riskOverview.selectPlaceholder")}
                                                            onChange={(e) => { getRiskDashboardDataFN(risk_id); financial_inherent_change(e.value); setHoveredData(null); }}
                                                            styles={customStyles}
                                                            components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                                            value={listImpact.find(impact => impact.value === formState.financial_inherent)}
                                                            className="my-custom-select text-sm"
                                                            classNamePrefix="my-custom-select"
                                                            context="financial"
                                                            setHoveredData={setHoveredData}
                                                        />
                                                    </div>

                                                    <div className="flex flex-col">
                                                        <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.operationalImpact")}</label>
                                                        <Select
                                                            placeholder={t("riskOverview.selectPlaceholder")}
                                                            options={listImpact}
                                                            onChange={(e) => { getRiskDashboardDataFN(risk_id); operational_inherent_change(e.value); setHoveredData(null); }}
                                                            styles={customStyles}
                                                            components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                                            value={listImpact.find(impact => impact.value === formState.operational_inherent)}
                                                            className="my-custom-select text-sm"
                                                            classNamePrefix="my-custom-select"
                                                            context="operational"
                                                            setHoveredData={setHoveredData}
                                                        />
                                                    </div>

                                                    <div className="flex flex-col">
                                                        <label className="text-[#3b3b3b] mb-2 text-sm">{mode === 'Compliance' ? t("riskOverview.complianceImpact") : t("riskOverview.reputationalImpact")}</label>
                                                        <Select
                                                            options={listImpact}
                                                            onChange={(e) => { getRiskDashboardDataFN(risk_id); reputational_inherent_change(e.value); setHoveredData(null); }}
                                                            styles={customStyles}
                                                            components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                                            value={listImpact.find(impact => impact.value === formState.reputational_inherent)}
                                                            className="my-custom-select text-sm"
                                                            classNamePrefix="my-custom-select"
                                                            placeholder={t("riskOverview.selectPlaceholder")}
                                                            context="reputational"
                                                            setHoveredData={setHoveredData}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Inherent Risk Score */}
                                                <div className="grid grid-cols-4 gap-4 mb-8">
                                                    <div className="flex flex-col items-start">
                                                        <span className="text-left text-sm text-[#3b3b3b]">{t("riskOverview.estimatedLoss")}</span>
                                                        <div className="bg-[#F07167] text-white h-10 rounded w-full mt-2 text-center flex items-center justify-center">${calculateFinancialLoss(formState.financial_inherent)}</div>
                                                    </div>
                                                    <div className="flex flex-col items-start">
                                                        <Badge
                                                            label={t("riskOverview.pillar.financial")}
                                                            trueVal={formState.financial_inherent_score}
                                                            value={formState.financial_inherent}
                                                            history={formState.financial_inherent_score_history}
                                                            description={t("riskOverview.pillarDescriptions.financial")}
                                                            icon={<span className="text-blue-600 font-bold">$</span>}
                                                            context="financial"
                                                        />
                                                    </div>

                                                    <div className="flex flex-col items-start">

                                                        <Badge
                                                            label={t("riskOverview.pillar.operational")}
                                                            context="operational"
                                                            trueVal={formState.operational_inherent_score}
                                                            value={formState.operational_inherent}
                                                            history={formState.operational_inherent_score_history}
                                                            description={t("riskOverview.pillarDescriptions.operational")}
                                                            icon={<span className="text-purple-600">⚙️</span>}
                                                        />
                                                    </div>
                                                    <div className="flex flex-col items-start">

                                                        <Badge
                                                            trueVal={formState.reputational_inherent_score}
                                                            label={t("riskOverview.pillar.reputational")}
                                                            value={formState.reputational_inherent}
                                                            history={formState.reputational_inherent_score_history}
                                                            description={t("riskOverview.pillarDescriptions.reputational")}
                                                            icon={<span className="text-orange-600">👥</span>}
                                                            context="reputational"
                                                        />
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="mb-6 bg-white rounded-lg shadow-sm border border-gray-200 pt-6 px-6 pb-1">
                                                <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.riskResponse")}</label>


                                                {/* Controls */}
                                                {/* <div className="mb-4 flex justify-between items-center">
                    <h3 className="font-semibold text-[#3b3b3b]">Controls</h3>
                    <button className="bg-[#3b3b3b] text-white py-2 px-4 rounded" onClick={() => addControlFN(risk_id)}>{t("riskOverview.addNewControl")}</button>
                </div>*/}

                                                <div className="mb-4 flex justify-between items-center">

                                                    <Select
                                                        options={listResponses}
                                                        placeholder={t("riskOverview.riskResponsePlaceholder")}
                                                        onChange={(e) => handleRiskChange({ ...formState, risk_response: e.value })}
                                                        styles={customStyles}
                                                        components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                                        value={listResponses.find(response => response.value === formState.risk_response)}
                                                        className="my-custom-select text-sm"
                                                        classNamePrefix="my-custom-select"
                                                        context=""
                                                        setHoveredData={setHoveredData}
                                                    />

                                                    {/* AI Suggestion Button */}
                                                    <div className="flex items-center gap-4 mt-2 mb-2">
                                                        <button
                                                            onClick={() => handleAISuggestions()}
                                                            className={`relative bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-white rounded px-4 py-2 shadow-lg transition duration-300 ease-in-out hover:shadow-2xl hover:scale-105 focus:outline-none ${loadingAI ? 'animate-pulse' : ''
                                                                }`}
                                                            disabled={loadingAI}
                                                            style={{
                                                                minWidth: '120px',
                                                                minHeight: '32px',
                                                                boxShadow: loadingAI
                                                                    ? '0 0 20px 5px rgba(139, 92, 246, 0.8)'
                                                                    : '0 0 5px rgba(0, 0, 0, 0.1)',
                                                            }}
                                                        >
                                                            <span className="absolute inset-0 rounded blur-md opacity-50 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500"></span>
                                                            <span className="relative">{t("riskOverview.askRabo")}</span>
                                                        </button>

                                                        <button
                                                            className="bg-[#3b3b3b] text-white py-2 px-4 rounded hover:bg-opacity-70"
                                                            onClick={() => handleAddControl(risk_id)}
                                                        >
                                                            Add New Control
                                                        </button>

                                                        {/* <button
                                                            className="bg-[#3b3b3b] text-white py-2 px-4 rounded hover:bg-opacity-70"
                                                            onClick={() => handleAssignControl(risk_id)}
                                                        >
                                                            {t("riskOverview.assignControl")}
                                                        </button> */}
                                                    </div>
                                                </div>


                                                {risk && risk.controls && (
                                                    <div
                                                        ref={combinedDropRef}
                                                        className={`border border-gray-200 rounded-xl overflow-hidden mb-6 ${(isOver || isAssignOver) ? "bg-blue-50" : "bg-white"
                                                            }`}
                                                    >

                                                        <table
                                                            {...getTableProps()}
                                                            className="w-full text-sm text-gray-800"
                                                            style={{
                                                                borderCollapse: "separate",
                                                                borderSpacing: 0,
                                                                tableLayout: "fixed",
                                                            }}
                                                        >
                                                            <thead>
                                                                {headerGroups.map((headerGroup) => (
                                                                    <tr
                                                                        {...headerGroup.getHeaderGroupProps()}
                                                                        className="border-b border-gray-300 bg-white"
                                                                    >
                                                                        {headerGroup.headers.map((column, idx) => {
                                                                            const w = column.columnWidth;
                                                                            const isFirst = idx === 0;
                                                                            const isLast = idx === headerGroup.headers.length - 1;

                                                                            return (
                                                                                <th
                                                                                    {...column.getHeaderProps()}
                                                                                    className={`text-left text-[13px] text-gray-800 font-semibold ${isFirst ? "rounded-tl-xl" : ""
                                                                                        } ${isLast ? "rounded-tr-xl" : ""}`}
                                                                                    style={{
                                                                                        background: "#fff",
                                                                                        padding: "0.6rem 0.75rem",
                                                                                        width: w ? `${w}px` : "auto",
                                                                                        minWidth: w ? `${w}px` : undefined,
                                                                                        maxWidth: w ? `${w}px` : undefined,
                                                                                        whiteSpace: "nowrap",
                                                                                    }}
                                                                                >
                                                                                    {column.render("Header")}
                                                                                </th>
                                                                            );
                                                                        })}
                                                                    </tr>
                                                                ))}
                                                            </thead>

                                                            <tbody {...getTableBodyProps()}>
                                                                {rows.length === 0 ? (
                                                                    <tr>
                                                                        <td
                                                                            colSpan={columns.length}
                                                                            className="text-sm text-gray-500 px-4 py-6"
                                                                        >
                                                                            {t("riskOverview.noControls")}
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    rows.map((row) => {
                                                                        prepareRow(row);
                                                                        return (
                                                                            <tr
                                                                                {...row.getRowProps()}
                                                                                className="group transition-colors duration-200 cursor-pointer"
                                                                                onClick={() => setControlId(row.original.controlID)}
                                                                            >
                                                                                {row.cells.map((cell) => (
                                                                                    <td
                                                                                        {...cell.getCellProps()}
                                                                                        className="border-t border-gray-200 group-hover:bg-[#F8F8F8] align-top relative"
                                                                                        style={{ padding: "0.65rem 1rem" }}
                                                                                        onClick={(e) => {
                                                                                            if (cell.column.id === "menu") e.stopPropagation();
                                                                                        }}
                                                                                    >
                                                                                        {cell.render("Cell")}
                                                                                    </td>

                                                                                ))}
                                                                            </tr>
                                                                        );
                                                                    })
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}

                                            </div>

                                            <div className="mb-6 bg-white rounded-lg shadow-sm border border-gray-200 pt-6 px-6 pb-1">
                                                {/* Residual Risk */}
                                                <h3 className="font-semibold mb-3 text-[#3b3b3b]">{t("riskOverview.residualAssessment")}</h3>
                                                <div className="grid grid-cols-4 gap-4 mb-4">


                                                    <div className="flex flex-col">
                                                        <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.probability")}</label>
                                                        <Select
                                                            options={listProbability}
                                                            placeholder={t("riskOverview.selectPlaceholder")}
                                                            onChange={(e) => { getRiskDashboardDataFN(risk_id); probability_residual_change(e.value); setHoveredData(null); }}
                                                            styles={customStyles}
                                                            components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                                            value={listProbability.find(probability => probability.value === formState.probability_residual)}
                                                            className="my-custom-select text-sm"
                                                            classNamePrefix="my-custom-select"
                                                            context="probability"
                                                            setHoveredData={setHoveredData}
                                                        />
                                                    </div>


                                                    <div className="flex flex-col">
                                                        <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.financialImpact")}</label>
                                                        <Select
                                                            options={listImpact}
                                                            placeholder={t("riskOverview.selectPlaceholder")}
                                                            onChange={(e) => { getRiskDashboardDataFN(risk_id); financial_residual_change(e.value); setHoveredData(null); }}
                                                            styles={customStyles}
                                                            components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                                            value={listImpact.find(impact => impact.value === formState.financial_residual)}
                                                            className="my-custom-select text-sm"
                                                            classNamePrefix="my-custom-select"
                                                            context="financial"
                                                            setHoveredData={setHoveredData}
                                                        />
                                                    </div>


                                                    <div className="flex flex-col">
                                                        <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.operationalImpact")}</label>
                                                        <Select
                                                            options={listImpact}
                                                            placeholder={t("riskOverview.selectPlaceholder")}
                                                            onChange={(e) => { getRiskDashboardDataFN(risk_id); operational_residual_change(e.value); setHoveredData(null); }}
                                                            styles={customStyles}
                                                            components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                                            value={listImpact.find(impact => impact.value === formState.operational_residual)}
                                                            className="my-custom-select text-sm"
                                                            classNamePrefix="my-custom-select"
                                                            context="operational"
                                                            setHoveredData={setHoveredData}
                                                        />
                                                    </div>


                                                    <div className="flex flex-col">
                                                        <label className="text-[#3b3b3b] mb-2 text-sm">{mode === 'Compliance' ? t("riskOverview.complianceImpact") : t("riskOverview.reputationalImpact")} </label>
                                                        <Select
                                                            options={listImpact}
                                                            placeholder={t("riskOverview.selectPlaceholder")}
                                                            onChange={(e) => { getRiskDashboardDataFN(risk_id); reputational_residual_change(e.value); setHoveredData(null); }}
                                                            styles={customStyles}
                                                            components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                                            value={listImpact.find(impact => impact.value === formState.reputational_residual)}
                                                            className="my-custom-select text-sm"
                                                            classNamePrefix="my-custom-select"
                                                            context="reputational"
                                                            setHoveredData={setHoveredData}
                                                        />
                                                    </div>

                                                </div>

                                                {/* Residual Risk Score */}
                                                <div className="grid grid-cols-4 gap-4 mb-8">
                                                    <div className="flex flex-col items-start">
                                                        <span className="text-left text-sm text-[#3b3b3b]">{t("riskOverview.estimatedLoss")}</span>
                                                        <div className="bg-[#F07167] text-white h-10 rounded w-full mt-2 text-center flex items-center justify-center">${calculateFinancialLoss(formState.financial_residual)}</div>
                                                    </div>
                                                    <div className="flex flex-col text-sm items-start">

                                                        <Badge
                                                            trueVal={formState.financial_residual_score}
                                                            label={t("riskOverview.pillar.financial")}
                                                            value={formState.financial_residual}
                                                            history={formState.financial_residual_score_history}
                                                            description={t("riskOverview.pillarDescriptions.financial")}
                                                            icon={<span className="text-blue-600 font-bold">$</span>}
                                                            context="financial"
                                                        />
                                                    </div>
                                                    <div className="flex flex-col items-start">

                                                        <Badge
                                                            label={t("riskOverview.pillar.operational")}
                                                            context="operational"
                                                            trueVal={formState.operational_residual_score}
                                                            value={formState.operational_residual}
                                                            history={formState.operational_residual_score_history}
                                                            description={t("riskOverview.pillarDescriptions.operational")}
                                                            icon={<span className="text-purple-600">⚙️</span>}
                                                        />
                                                    </div>
                                                    <div className="flex flex-col items-start">

                                                        <Badge
                                                            trueVal={formState.reputational_residual_score}
                                                            label={t("riskOverview.pillar.reputational")}
                                                            value={formState.reputational_residual}
                                                            history={formState.reputational_residual_score_history}
                                                            description={t("riskOverview.pillarDescriptions.reputational")}
                                                            icon={<span className="text-orange-600">👥</span>}
                                                            context="reputational"
                                                        />
                                                    </div>

                                                </div>


                                            </div>

                                            {/* Actions */}
                                            {(formState.risk_response === "Mitigate" || formState.risk_response === "Avoid") && <div className="mb-6 bg-white rounded-lg shadow-sm border border-gray-200 pt-6 px-6 pb-1">
                                                <div className="mb-4 flex justify-between items-center">
                                                    <h3 className="font-semibold text-[#3b3b3b]">Actions</h3>
                                                    <button className="bg-[#3b3b3b] text-white py-2 px-4 rounded" onClick={() => handleAddAction(risk_id)}>Add New Action</button>
                                                </div>

                                                {risk && risk.actions && risk.actions?.length > 0 && <div className="table w-full mb-6 border border-gray-300 rounded-lg bg-[#F8F8F8] relative z-10">
                                                    <div className="table-row bg-[#F8F8F8]">
                                                        <div className="table-cell p-4 -b  font-semibold w-[50px]">No</div>
                                                        <div className="table-cell p-4 -b  font-semibold">Title</div>
                                                        {/*<div className="table-cell p-4 -b  font-semibold">Progress</div>
                                <div className="table-cell p-4 -b  font-semibold">Start</div>
                                <div className="table-cell p-4 -b  font-semibold">End</div>
                                <div className="table-cell p-4 -b  font-semibold">Priority</div>*/}
                                                        <div className="table-cell p-4 -b  font-semibold"></div>
                                                    </div>

                                                    {risk && risk.actions && risk.actions?.length > 0 && risk.actions.map((action, index) => (
                                                        <div className="table-row bg-white z-0 hover:bg-[#f8f8f8] hover:shadow-sm transition cursor-pointer"
                                                            onClick={() => {
                                                                setActionId(action.ActionID);

                                                            }}>
                                                            <div className="table-cell p-2 border-b border-gray-300 w-[50px] align-middle">
                                                                <span className="font-semibold">{action.ActionNumber}</span>
                                                            </div>
                                                            <div className="table-cell p-2 border-b border-gray-300 align-middle">
                                                                {/* <ContentEditable
                                    html={formActionState[index]?.ActionTitle || ''}
                                    onChange={(e) => handleActionChange(index, 'ActionTitle', e.target.value, action.ActionID)}
                                /> */}
                                                                <input
                                                                    type="text"
                                                                    //value={formActionState[index]?.ActionTitle || ''}
                                                                    //onChange={(e) => handleActionChange({ ...formActionState, ActionTitle: e.target.value }, )}
                                                                    //onChange={(e) => handleActionChange(index, 'ActionTitle', e.target.value, action.ActionID)}
                                                                    className='w-[400px] p-2  hover:bg-[#f8f8f8] cursor-pointer'
                                                                    value={formActionState.find(a => a.ActionID === action.ActionID)?.ActionTitle || ''}
                                                                    onClick={() => {
                                                                        setActionId(action.ActionID);

                                                                    }}
                                                                    readOnly
                                                                    onChange={(e) => {
                                                                        const action_id = action.ActionID;
                                                                        const updatedActions = [...formActionState];
                                                                        //update the control details by control_id instead of index
                                                                        const actionToUpdate = updatedActions.find(a => a.ActionID === action_id);
                                                                        if (actionToUpdate) {
                                                                            actionToUpdate.ActionTitle = e.target.value;
                                                                        }

                                                                        //handleActionChange(updatedActions, action_id);
                                                                    }}


                                                                />
                                                            </div>


                                                            <div className="table-cell p-4 border-b border-gray-300">
                                                                <div className="relative inline-block">
                                                                    <i
                                                                        className="fa fa-ellipsis-h cursor-pointer text-[#3b3b3b] hover:text-[#3b3b3b]/50 ml-6"
                                                                        title="More"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            toggleMenu(`action-${action.ActionID}`);
                                                                        }}
                                                                    />
                                                                    {menuOpenId === `action-${action.ActionID}` && (
                                                                        <div
                                                                            className="absolute right-0 mt-2 w-36 bg-white border border-gray-200 rounded-md shadow-lg z-999"
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        >
                                                                            <button
                                                                                className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100"
                                                                                onClick={() => {
                                                                                    setMenuOpenId(null);
                                                                                    setActionId(action.ActionID);

                                                                                }}
                                                                            >
                                                                                Edit
                                                                            </button>
                                                                            <button
                                                                                className="w-full text-left px-3 py-2 text-sm text-red-600 hover:bg-red-50"
                                                                                onClick={() => {
                                                                                    setMenuOpenId(null);
                                                                                    handleDeleteAction(risk_id, action.ActionID); // Delete
                                                                                }}
                                                                            >
                                                                                Delete
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>}
                                            </div>}

                                            <div className="mb-6 bg-white rounded-lg shadow-sm border border-gray-200 pt-6 px-6 pb-1">
                                                {/* Future Risk */}
                                                <h3 className="font-semibold mb-3 text-[#3b3b3b]">{t("riskOverview.futureAssessment")}</h3>
                                                <div className="grid grid-cols-4 gap-4 mb-4">


                                                    <div className="flex flex-col">
                                                        <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.probability")}</label>
                                                        <Select
                                                            options={listProbability}
                                                            placeholder={t("riskOverview.selectPlaceholder")}
                                                            onChange={(e) => { getRiskDashboardDataFN(risk_id); probability_future_change(e.value); setHoveredData(null); }}
                                                            styles={customStyles}
                                                            components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                                            value={listProbability.find(probability => probability.value === formState.probability_future)}
                                                            className="my-custom-select text-sm"
                                                            classNamePrefix="my-custom-select"
                                                            context="probability"
                                                            setHoveredData={setHoveredData}
                                                        />
                                                    </div>

                                                    <div className="flex flex-col">
                                                        <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.financialImpact")}</label>
                                                        <Select
                                                            options={listImpact}
                                                            placeholder={t("riskOverview.selectPlaceholder")}
                                                            onChange={(e) => { getRiskDashboardDataFN(risk_id); financial_future_change(e.value); setHoveredData(null); }}
                                                            styles={customStyles}
                                                            components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                                            value={listImpact.find(impact => impact.value === formState.financial_future)}
                                                            className="my-custom-select text-sm"
                                                            classNamePrefix="my-custom-select"
                                                            context="financial"
                                                            setHoveredData={setHoveredData}
                                                        />

                                                    </div>

                                                    <div className="flex flex-col">
                                                        <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.operationalImpact")}</label>
                                                        <Select
                                                            options={listImpact}
                                                            placeholder={t("riskOverview.selectPlaceholder")}
                                                            onChange={(e) => { getRiskDashboardDataFN(risk_id); operational_future_change(e.value); setHoveredData(null); }}
                                                            styles={customStyles}
                                                            components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                                            value={listImpact.find(impact => impact.value === formState.operational_future)}
                                                            className="my-custom-select text-sm"
                                                            classNamePrefix="my-custom-select"
                                                            context="operational"
                                                            setHoveredData={setHoveredData}
                                                        />

                                                    </div>

                                                    <div className="flex flex-col">
                                                        <label className="text-[#3b3b3b] mb-2 text-sm">{mode === 'Compliance' ? t("riskOverview.complianceImpact") : t("riskOverview.reputationalImpact")}</label>
                                                        <Select
                                                            options={listImpact}
                                                            placeholder={t("riskOverview.selectPlaceholder")}
                                                            onChange={(e) => { getRiskDashboardDataFN(risk_id); reputational_future_change(e.value); setHoveredData(null); }}
                                                            styles={customStyles}
                                                            components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                                            value={listImpact.find(impact => impact.value === formState.reputational_future)}
                                                            className="my-custom-select text-sm"
                                                            classNamePrefix="my-custom-select"
                                                            context="reputational"
                                                            setHoveredData={setHoveredData}
                                                        />

                                                    </div>
                                                </div>


                                                {/* Future Risk Score */}
                                                <div className="grid grid-cols-4 gap-4 mb-8">
                                                    <div className="flex flex-col items-start">
                                                        <span className="text-left text-sm text-[#3b3b3b]">{t("riskOverview.estimatedLoss")}</span>
                                                        <div className="bg-[#F07167] text-white h-10 rounded w-full mt-2 text-center flex items-center justify-center">${calculateFinancialLoss(formState.financial_future)}</div>
                                                    </div>
                                                    <div className="flex flex-col items-start">

                                                        <Badge
                                                            trueVal={formState.financial_future_score}
                                                            label={t("riskOverview.pillar.financial")}
                                                            value={formState.financial_future}
                                                            history={formState.financial_future_score_history}
                                                            description={t("riskOverview.pillarDescriptions.financial")}
                                                            icon={<span className="text-blue-600 font-bold">$</span>}
                                                            context="financial"
                                                        />
                                                    </div>
                                                    <div className="flex flex-col items-start">

                                                        <Badge
                                                            trueVal={formState.operational_future_score}
                                                            label={t("riskOverview.pillar.operational")}
                                                            context="operational"
                                                            value={formState.operational_future}
                                                            history={formState.operational_future_score_history}
                                                            description={t("riskOverview.pillarDescriptions.operational")}
                                                            icon={<span className="text-purple-600">⚙️</span>}
                                                        />
                                                    </div>
                                                    <div className="flex flex-col items-start">

                                                        <Badge
                                                            trueVal={formState.reputational_future_score}
                                                            label={t("riskOverview.pillar.reputational")}
                                                            value={formState.reputational_future}
                                                            history={formState.reputational_future_score_history}
                                                            description={t("riskOverview.pillarDescriptions.reputational")}
                                                            icon={<span className="text-orange-600">👥</span>}
                                                            context="reputational"
                                                        />
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="mb-6 bg-white rounded-lg shadow-sm border border-gray-200 pt-6 px-6 pb-1">
                                                <h3 className="font-semibold mb-3 text-[#3b3b3b]">{t("riskOverview.strategicImpact")}</h3>
                                                <div className="grid grid-cols-4 gap-4 mb-6">



                                                    <div className="flex flex-col">
                                                        {/* <label className="text-[#3b3b3b] mb-2 text-sm">Strategic Impact</label> */}
                                                        <Select
                                                            placeholder={t("riskOverview.selectPlaceholder")}
                                                            options={listImpact}
                                                            onChange={(e) => { handleRiskChange({ ...formState, StrategicImpact: e.value }); setHoveredData(null); }}
                                                            styles={customStyles}
                                                            components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                                            value={listImpact.find(impact => impact.value === formState.StrategicImpact)}
                                                            className="my-custom-select text-sm"
                                                            classNamePrefix="my-custom-select"
                                                            context="strategic"
                                                            setHoveredData={setHoveredData}
                                                        />
                                                    </div>

                                                    <button className="bg-[#3b3b3b] text-white py-2 px-4 rounded hover:bg-opacity-70" onClick={() => setIsIncidentOpen(true)}>{t("riskOverview.reportIncident")}</button>

                                                </div>
                                            </div>




                                            <div className="mb-6 bg-white rounded-lg shadow-sm border border-gray-200 pt-6 px-6 pb-1">
                                                <h3 className="font-semibold mb-3 text-[#3b3b3b]">{t("riskOverview.comments")}</h3>

                                                {/* Comments */}
                                                <div className="mb-6">
                                                    <textarea
                                                        placeholder={t("riskOverview.commentsPlaceholder")}
                                                        className="w-full p-3   rounded bg-[#F8F8F8] text-black"
                                                        value={commentState}
                                                        onChange={(e) => setCommentState(e.target.value)}
                                                    />

                                                    <div className="flex justify-end mt-4">
                                                        <button className="bg-[#3b3b3b] text-white py-2 px-4 rounded hover:bg-opacity-70" onClick={() => { if (commentState) { handleAddComment(risk_id); setCommentState(''); } }}>{t("riskOverview.addComment")}</button>
                                                    </div>

                                                </div>

                                                {/* Mark Jones Comment */}

                                                {
                                                    risk && risk.comments && risk.comments?.length > 0 && risk.comments.map((comment, index) => (
                                                        <div className="bg-[#F8F8F8] p-4 rounded-[5px] text-gray-600 mb-4">
                                                            <div className="flex justify-between">
                                                                <span className="font-semibold">{comment.FirstName} {comment.LastName}</span>
                                                                <span>{moment(comment.CommentDate).format('MM/DD/YYYY HH:mm:ss')}</span>
                                                            </div>
                                                            <p className="mt-2">{comment.CommentText}</p>
                                                        </div>
                                                    ))
                                                }

                                            </div>
                                        </div >
                                    </div>

                                    {/* Floating AI Suggested Controls */}
                                    {controls?.length > 0 && (
                                        <div
                                            className={`fixed right-6 top-16 w-[340px] bg-transparent rounded-md p-4 transition-all duration-500 ease-in-out ${showControls ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
                                                }`}
                                            style={{
                                                zIndex: 1050,
                                                pointerEvents: "auto",
                                            }}
                                        >
                                            {controls.map((control) => (
                                                <DraggableControlCard
                                                    key={control.id}
                                                    control={control}
                                                    onRemove={() => onRemoveControl(control.id)}
                                                    framework={framework}
                                                />
                                            ))}
                                        </div>
                                    )}

                                    <Popup open={control_id != null} modal nested closeOnDocumentClick={false} closeOnEscape
                                        contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '900px', marginTop: '14vh', zIndex: 1000 }}
                                        overlayStyle={{ zIndex: 999 }}
                                    >
                                        <ControlOverlay key={control_id || 'new-control'} closeControl={closeControl} risk_id={risk_id} control_id={control_id} />
                                    </Popup>


                                    <Popup
                                        open={action_id != null}
                                        contentStyle={{ overflow: 'auto', maxHeight: '100vh', width: '900px', marginTop: '14vh' }}
                                    >
                                        <ActionOverlay closeAction={closeAction} risk_id={risk_id} action_id={action_id} />
                                    </Popup>

                                    <Popup
                                        open={isIncidentOpen}
                                        onClose={closeIncident}
                                        contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '810px', marginTop: '14vh' }}
                                    >
                                        <IncidentDetailsForm is_new={true} closeIncident={closeIncident} risk_id={risk_id} />
                                    </Popup>

                              

                                    {isAssignControlsOpen && (
                                       <div className="fixed inset-0 z-[9999] pointer-events-none">
                                            {/* backdrop */}
                                            <div
                                                className={`absolute inset-0 bg-black/30 ${isDraggingAssignControl ? "pointer-events-none" : "pointer-events-auto"
                                                    }`}
                                                onClick={() => {
                                                    if (!isDraggingAssignControl) setIsAssignControlsOpen(false);
                                                }}
/>

                                            {/* panel */}
                                           <div className="absolute right-0 top-0 h-full w-[520px] bg-white shadow-xl border-l border-gray-200 flex flex-col pointer-events-auto">
                                                <div className="p-4 border-b border-gray-200 flex items-center justify-between">
                                                    <button
                                                        className="text-sm text-gray-600 hover:text-gray-900"
                                                        onClick={() => setIsAssignControlsOpen(false)}
                                                    >
                                                        ✕
                                                    </button>
                                                </div>

                                                <div className="p-3 border-b border-gray-100">
                                                    <div className="text-xs text-gray-500">
                                                        {t("riskOverview.assignPanelHint")}
                                                    </div>
                                                </div>

                                                <div className="flex-1 overflow-auto">
                                                    {assignCandidates.length === 0 ? (
                                                        <div className="p-6 text-sm text-gray-500">{t("riskOverview.noAssignableControls")}</div>
                                                    ) : (
                                                            <div className="divide-y divide-gray-100">
                                                                {assignCandidates.map((ctrl) => {
                                                                    const id = ctrl.controlID ?? ctrl.ControlID ?? ctrl.control_id;
                                                                    const riskIds = (ctrl.RiskIds || ctrl.riskIds || []).map(Number);

                                                                    ////console.log("render candidate", id);

                                                                    return (
                                                                        <AssignControlRow
                                                                            key={id}
                                                                            ctrl={ctrl}
                                                                            id={id}
                                                                            riskIds={riskIds}
                                                                        />
                                                                    );
                                                                })}
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="p-4 border-t border-gray-200 flex items-center justify-end gap-2">
                                                    <button
                                                        className="px-3 py-2 text-sm rounded-lg border border-gray-200 hover:bg-gray-50"
                                                        onClick={() => setIsAssignControlsOpen(false)}
                                                    >
                                                        {t("riskOverview.closePanel")}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="col-span-1 min-w-0">
                                <div
                                    className="sticky top-[64px]"
                                    style={{ paddingTop: MATRIX_TOP_PAD }}
                                >
                                    {showMatrices && (
                                        <div className="flex justify-start">
                                            <div
                                                className="bg-white border border-gray-200 rounded-lg p-2"
                                                style={{ width: `${MATRIX_WRAP_PCT * 100}%` }}
                                            >
                                                <div className="flex flex-col gap-2">

                                                    {/* Financial */}
                                                    <div className="bg-white border border-gray-200 rounded-lg p-2">
                                                        <div className="flex items-center gap-2 mb-1">
                                                            <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-blue-50">
                                                                <span className="text-blue-600 font-bold text-xs">$</span>
                                                            </span>
                                                            <span className="text-xs font-semibold text-gray-800">{t("riskOverview.pillar.financial")}</span>
                                                        </div>

                                                        {/* square */}
                                                        <div className="flex justify-center">
                                                            <div className="w-[85%] aspect-square">
                                                                <RiskMatrixSingle
                                                                    title={null}
                                                                    points={risk_dashboard_data?.risk_matrix?.financial || []}
                                                                    matrixId="fin"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="mt-1 text-[10px] text-gray-600 flex items-center justify-between px-1">
                                                            <span>{t("riskOverview.matrix.likelihood")}</span>
                                                            <span>{t("riskOverview.matrix.impact")}</span>
                                                        </div>
                                                    </div>

                                                    {/* Operational */}
                                                    <div className="bg-white border border-gray-200 rounded-lg p-2">
                                                        <div className="flex items-center gap-2 mb-1">
                                                            <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-purple-50">
                                                                <span className="text-purple-600 text-xs">⚙️</span>
                                                            </span>
                                                            <span className="text-xs font-semibold text-gray-800">{t("riskOverview.pillar.operational")}</span>
                                                        </div>

                                                        {/* square */}
                                                        <div className="flex justify-center">
                                                            <div className="w-[85%] aspect-square">
                                                                <RiskMatrixSingle
                                                                    title={null}
                                                                    points={risk_dashboard_data?.risk_matrix?.operational || []}
                                                                    matrixId="op"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="mt-1 text-[10px] text-gray-600 flex items-center justify-between px-1">
                                                            <span>{t("riskOverview.matrix.likelihood")}</span>
                                                            <span>{t("riskOverview.matrix.impact")}</span>
                                                        </div>
                                                    </div>

                                                    {/* Reputational */}
                                                    <div className="bg-white border border-gray-200 rounded-lg p-2">
                                                        <div className="flex items-center gap-2 mb-1">
                                                            <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-orange-50">
                                                                <span className="text-orange-600 text-xs">👥</span>
                                                            </span>
                                                            <span className="text-xs font-semibold text-gray-800">{t("riskOverview.pillar.reputational")}</span>
                                                        </div>

                                                        {/* square */}
                                                        <div className="flex justify-center">
                                                            <div className="w-[85%] aspect-square">
                                                                <RiskMatrixSingle
                                                                    title={null}
                                                                    points={risk_dashboard_data?.risk_matrix?.reputational || []}
                                                                    matrixId="rep"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="mt-1 text-[10px] text-gray-600 flex items-center justify-between px-1">
                                                            <span>{t("riskOverview.matrix.likelihood")}</span>
                                                            <span>{t("riskOverview.matrix.impact")}</span>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>






    );
};


const mapStateToProps = (state) => {
  const departments = state.department.departments || [];

  const complianceStandards = departments.filter(
    (d) => String(d.framework) === "2"
  );
    //console.log("Risk ", state.risk.risk)
    return {
        risk: state.risk.risk,
        profile: state.profile.profile,
        levels: state.risk.levels,
        risk_id: state.risk.id,
        framework: state.risk.risk?.risk?.Framework,
        activeDepartmentId: state.department.activeDepartmentId,
        mode: state.risk.risk?.risk?.framework === 2 ? "Compliance" : "Department",
        risk_dashboard_data: state.dashboard.risk_dashboard_data,
        complianceStandards: complianceStandards,
        departments: departments,
        go_to_bowtie: state.risk.go_to_bowtie,
        go_to_risk_dashboard: state.risk.go_to_risk_dashboard, 
        companies: state.department.companies,
        sidebar_collapsed: state.auth.sidebar_collapsed,
        activeComplianceId: state.compliance.activeComplianceId,
        assignable_controls: state.risk?.risk_controls,
    };
};

const mapDispatchToProps = (dispatch) => {

    return {
        getRiskFN: (id) => dispatch(getRisk(id)),
        addCommentFN: (comment, risk_id) => dispatch(addComment(comment, risk_id)),
        addControlFN: (risk_id, owner_id) => {
            return dispatch(addControl(risk_id, owner_id));  // Ensure it returns the Promise
        },
        addActionFN: (risk_id) => dispatch(addAction(risk_id)),
        addAttachmentFN: (risk_id, control_id, file) => dispatch(addAttachment(risk_id, control_id, file)),
        editRiskFN: (risk_id, risk) => dispatch(editRisk(risk_id, risk)),
        editRiskSaveFN: (risk_id, risk) => dispatch(editRiskSave(risk_id, risk)),
        editControlFN: (risk_id, control_id, control) => dispatch(editControl(risk_id, control_id, control)),
        editActionFN: (risk_id, action_id, action) => dispatch(editAction(risk_id, action_id, action)),
        deleteControlFN: (risk_id, action_id) => dispatch(deleteControl(risk_id, action_id)),
        deleteActionFN: (risk_id, action_id) => dispatch(deleteAction(risk_id, action_id)),
        getLevelsFN: (id) => dispatch(getLevels(id)),
        aiControlDropFN: (risk_id, control_data) => dispatch(aiControlDrop(risk_id, control_data)),
        closeOverlayFN: () => dispatch(closeOverlay()),
        closeIncidentFN: () => dispatch(closeIncident()),
        getRiskDashboardDataFN: (risk_id) => dispatch(getRiskDashboardData(risk_id)),
        getComplianceStandardsByCompanyFN: () => dispatch(getComplianceStandardsByCompany()),
        gotoBowtieFN: (id) => dispatch(gotoBowtie(id)),
        gotoRiskDashboardFN: (id) => dispatch(gotoRiskDashboard(id)),
        setSidebarCollapsedFN: (collapsed) =>
            dispatch(setSidebarCollapsed(collapsed)),
        getControlsReportFN: (departmentId) => dispatch(getControls_Report(departmentId)),
        assignControlToRiskFN: (control_id, risk_id) => dispatch(assignControlToRisk(control_id, risk_id))
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(RiskPage);